const localeRegistry = new Map();
// Built-in locales are auto-registered on import via their respective files

const en = {
    locale: 'en',
    dir: 'ltr',
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    dateFormat: 'mm/dd/yyyy',
    timeFormat: 'hh:MM A',
    dateTimeFormat: 'mm/dd/yyyy hh:MM A',
    setText: 'Set',
    cancelText: 'Cancel',
    clearText: 'Clear',
    nowText: 'Now',
    selectedText: 'selected',
    ofText: 'of',
    firstDay: 0,
};
localeRegistry.set('en', en);

const de = {
    locale: 'de',
    dir: 'ltr',
    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dateFormat: 'dd.mm.yyyy',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'dd.mm.yyyy HH:MM',
    setText: 'Übernehmen',
    cancelText: 'Abbrechen',
    clearText: 'Löschen',
    nowText: 'Jetzt',
    selectedText: 'ausgewählt',
    ofText: 'von',
    firstDay: 1,
};
localeRegistry.set('de', de);

const fr = {
    locale: 'fr',
    dir: 'ltr',
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    dateFormat: 'dd/mm/yyyy',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'dd/mm/yyyy HH:MM',
    setText: 'Valider',
    cancelText: 'Annuler',
    clearText: 'Effacer',
    nowText: 'Maintenant',
    selectedText: 'sélectionnés',
    ofText: 'sur',
    firstDay: 1,
};
localeRegistry.set('fr', fr);

const es = {
    locale: 'es',
    dir: 'ltr',
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
    dateFormat: 'dd/mm/yyyy',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'dd/mm/yyyy HH:MM',
    setText: 'Aceptar',
    cancelText: 'Cancelar',
    clearText: 'Borrar',
    nowText: 'Ahora',
    selectedText: 'seleccionados',
    ofText: 'de',
    firstDay: 1,
};
localeRegistry.set('es', es);

const it = {
    locale: 'it',
    dir: 'ltr',
    monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
    monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
    dateFormat: 'dd/mm/yyyy',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'dd/mm/yyyy HH:MM',
    setText: 'Conferma',
    cancelText: 'Annulla',
    clearText: 'Cancella',
    nowText: 'Adesso',
    selectedText: 'selezionati',
    ofText: 'di',
    firstDay: 1,
};
localeRegistry.set('it', it);

const pt = {
    locale: 'pt',
    dir: 'ltr',
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sá'],
    dateFormat: 'dd/mm/yyyy',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'dd/mm/yyyy HH:MM',
    setText: 'Confirmar',
    cancelText: 'Cancelar',
    clearText: 'Limpar',
    nowText: 'Agora',
    selectedText: 'selecionados',
    ofText: 'de',
    firstDay: 1,
};
localeRegistry.set('pt', pt);

const nl = {
    locale: 'nl',
    dir: 'ltr',
    monthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    dayNamesShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    dayNamesMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    dateFormat: 'dd-mm-yyyy',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'dd-mm-yyyy HH:MM',
    setText: 'Bevestigen',
    cancelText: 'Annuleren',
    clearText: 'Wissen',
    nowText: 'Nu',
    selectedText: 'geselecteerd',
    ofText: 'van',
    firstDay: 1,
};
localeRegistry.set('nl', nl);

const pl = {
    locale: 'pl',
    dir: 'ltr',
    monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
    monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    dayNamesShort: ['Ndz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
    dayNamesMin: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
    dateFormat: 'dd.mm.yyyy',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'dd.mm.yyyy HH:MM',
    setText: 'Zatwierdź',
    cancelText: 'Anuluj',
    clearText: 'Wyczyść',
    nowText: 'Teraz',
    selectedText: 'wybranych',
    ofText: 'z',
    firstDay: 1,
};
localeRegistry.set('pl', pl);

const ja = {
    locale: 'ja',
    dir: 'ltr',
    monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
    dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
    dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
    dateFormat: 'yyyy/mm/dd',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'yyyy/mm/dd HH:MM',
    setText: '決定',
    cancelText: 'キャンセル',
    clearText: 'クリア',
    nowText: '今',
    selectedText: '件選択済み',
    ofText: '/',
    firstDay: 0,
};
localeRegistry.set('ja', ja);

const zh = {
    locale: 'zh',
    dir: 'ltr',
    monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
    dateFormat: 'yyyy/mm/dd',
    timeFormat: 'HH:MM',
    dateTimeFormat: 'yyyy/mm/dd HH:MM',
    setText: '确定',
    cancelText: '取消',
    clearText: '清除',
    nowText: '现在',
    selectedText: '已选择',
    ofText: '/',
    firstDay: 1,
};
localeRegistry.set('zh', zh);

/** Desktop has room for several dropdowns side by side; a phone sheet covers the screen. */
const DEFAULT_MULTI_OPEN = { desktop: true, mobile: false };
const DEFAULT_OPTIONS = {
    mode: 'date',
    display: 'anchored',
    theme: 'auto',
    locale: 'en',
    min: null,
    max: null,
    disabled: null,
    minRange: null,
    maxRange: null,
    labels: {},
    presets: null,
    responsive: {},
    dateFormat: null,
    timeFormat: null,
    stepMinute: 1,
    stepHour: 1,
    calendarMonths: 1,
    calendarView: 'month',
    showQuarterYearPicker: false,
    showOuterDays: true,
    showWeekNumbers: false,
    selectMultiple: false,
    selectMax: null,
    highlightWeekends: true,
    headerText: '',
    setText: '',
    cancelText: '',
    cssClass: null,
    allowMultipleOpen: { ...DEFAULT_MULTI_OPEN },
    onInit: null,
    onOpen: null,
    onClose: null,
    onSet: null,
    onChange: null,
    onCancel: null,
    onDestroy: null,
};
function deepMerge(target, source) {
    const result = { ...target };
    const src = source;
    const tgt = target;
    for (const key of Object.keys(src)) {
        const val = src[key];
        if (val !== undefined) {
            if (val !== null &&
                typeof val === 'object' &&
                !Array.isArray(val) &&
                !(val instanceof Date) &&
                typeof tgt[key] === 'object' &&
                tgt[key] !== null &&
                !Array.isArray(tgt[key]) &&
                !(tgt[key] instanceof Date)) {
                result[key] = deepMerge(tgt[key], val);
            }
            else {
                result[key] = val;
            }
        }
    }
    return result;
}
function resolveOptions(userOptions) {
    return deepMerge(DEFAULT_OPTIONS, userOptions);
}
/**
 * True for the overlay sheet displays — the library's own notion of "mobile", used both for
 * layout decisions and to pick the `allowMultipleOpen` context.
 */
function isMobileDisplay(display) {
    return display === 'bottom' || display === 'top' || display === 'center';
}
/**
 * Resolves `allowMultipleOpen` against the display the picker actually renders in.
 * A partial object keeps the built-in default for whichever key it leaves out, so
 * `{ mobile: true }` does not silently change desktop behaviour.
 */
function allowsMultipleOpen(options) {
    const setting = options.allowMultipleOpen;
    if (typeof setting === 'boolean')
        return setting;
    const context = isMobileDisplay(options.display) ? 'mobile' : 'desktop';
    const value = setting?.[context];
    return typeof value === 'boolean' ? value : DEFAULT_MULTI_OPEN[context];
}

const openPickers = new Set();
function registerOpenPicker(picker) {
    openPickers.add(picker);
}
function unregisterOpenPicker(picker) {
    openPickers.delete(picker);
}
/**
 * Cancels every registered picker except `keep`, discarding their in-flight selection the same
 * way a click on the backdrop or outside an anchored dropdown does.
 *
 * Iterates a snapshot: `cancel()` unregisters as it goes, and the `onCancel`/`onClose`
 * callbacks it fires may open or close further pickers.
 */
function closeOtherPickers(keep) {
    for (const picker of [...openPickers]) {
        if (picker !== keep)
            picker.cancel();
    }
}

const BREAKPOINTS = [
    { name: 'xsmall', minWidth: 0 },
    { name: 'small', minWidth: 576 },
    { name: 'medium', minWidth: 768 },
    { name: 'large', minWidth: 1024 },
    { name: 'xlarge', minWidth: 1280 },
];
/**
 * True below the `small` breakpoint — a phone in portrait, where there is no horizontal
 * room to place calendar months side by side.
 *
 * Read at render time rather than cached: ResponsiveManager tears down and rebuilds the
 * picker when a breakpoint boundary is crossed, and a portrait/landscape rotation crosses
 * this one, so the next render always sees the current value.
 */
function isNarrowViewport() {
    return window.innerWidth < BREAKPOINTS[1].minWidth;
}
class ResponsiveManager {
    constructor(baseOptions, callback) {
        this._queries = [];
        this._baseOptions = baseOptions;
        this._callback = callback;
        this._currentBreakpoint = this._detectBreakpoint();
        this._setupListeners();
    }
    getActiveBreakpoint() {
        return this._currentBreakpoint;
    }
    getActiveOptions() {
        return this._mergeForBreakpoint(this._currentBreakpoint);
    }
    updateBaseOptions(options) {
        this._baseOptions = options;
    }
    destroy() {
        for (const { mql, handler } of this._queries) {
            mql.removeEventListener('change', handler);
        }
        this._queries = [];
    }
    _detectBreakpoint() {
        const width = window.innerWidth;
        let matched = BREAKPOINTS[0].name;
        for (const bp of BREAKPOINTS) {
            if (width >= bp.minWidth) {
                matched = bp.name;
            }
        }
        return matched;
    }
    _mergeForBreakpoint(breakpoint) {
        let merged = { ...this._baseOptions };
        const bpIndex = BREAKPOINTS.findIndex(b => b.name === breakpoint);
        // Apply all breakpoint overrides up to and including current
        for (let i = 0; i <= bpIndex; i++) {
            const bpName = BREAKPOINTS[i].name;
            const overrides = this._baseOptions.responsive[bpName];
            if (overrides) {
                merged = deepMerge(merged, overrides);
            }
        }
        return merged;
    }
    _setupListeners() {
        for (const bp of BREAKPOINTS) {
            if (bp.minWidth === 0)
                continue; // xsmall has no media query — it's the default
            const mql = window.matchMedia(`(min-width: ${bp.minWidth}px)`);
            const handler = () => {
                const newBp = this._detectBreakpoint();
                if (newBp !== this._currentBreakpoint) {
                    this._currentBreakpoint = newBp;
                    this._callback(newBp, this._mergeForBreakpoint(newBp));
                }
            };
            mql.addEventListener('change', handler);
            this._queries.push({ bp, mql, handler });
        }
    }
}

class ThemeManager {
    constructor(root, mode) {
        this._mediaQuery = null;
        this._mediaHandler = null;
        this._root = root;
        this._mode = mode;
        this._apply();
    }
    setMode(mode) {
        this._cleanup();
        this._mode = mode;
        this._apply();
    }
    destroy() {
        this._cleanup();
    }
    _apply() {
        this._root.classList.remove('dtp-theme-light', 'dtp-theme-dark', 'dtp-theme-auto');
        switch (this._mode) {
            case 'light':
                this._root.classList.add('dtp-theme-light');
                break;
            case 'dark':
                this._root.classList.add('dtp-theme-dark');
                break;
            case 'auto':
                this._root.classList.add('dtp-theme-auto');
                // Also set explicit class for JS consumers that want to query it
                this._setupAutoDetection();
                break;
        }
    }
    _setupAutoDetection() {
        if (typeof window.matchMedia !== 'function')
            return;
        this._mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        this._mediaHandler = () => {
            // The CSS handles the visual switch via the @media query in theme-dark.css.
            // This handler is available for consumers who need to react in JS.
        };
        this._mediaQuery.addEventListener('change', this._mediaHandler);
    }
    _cleanup() {
        if (this._mediaQuery && this._mediaHandler) {
            this._mediaQuery.removeEventListener('change', this._mediaHandler);
            this._mediaQuery = null;
            this._mediaHandler = null;
        }
    }
}

function createElement(tag, className, parent) {
    const el = document.createElement(tag);
    if (className)
        el.className = className;
    if (parent)
        parent.appendChild(el);
    return el;
}
function addClass(el, ...classes) {
    el.classList.add(...classes.filter(Boolean));
}
function setAttr(el, attrs) {
    for (const [key, value] of Object.entries(attrs)) {
        el.setAttribute(key, value);
    }
}

/**
 * Pins an element to the visual viewport.
 *
 * iOS Safari resolves `position: fixed` against the *layout* viewport, which does not
 * track the URL bar collapsing as you scroll, and does not track pinch-zoom panning.
 * A bottom sheet anchored with `bottom: 0` therefore floats above the URL bar, and
 * drifts sideways once the page is zoomed.
 *
 * Sizing the element to `visualViewport` and translating it by the viewport offset keeps
 * it flush with what the user actually sees. The translate is load-bearing twice over:
 * it cancels the zoom/scroll offset, and it makes the element a containing block, so
 * `position: fixed` children (the sheets) resolve against the visible rect rather than
 * the layout viewport.
 *
 * Returns a teardown function. On browsers without `visualViewport` the CSS fallback
 * (`100dvh`, then `100vh`) already covers the URL-bar case, so this is a no-op.
 */
function bindVisualViewport(el) {
    const vv = window.visualViewport;
    if (!vv)
        return () => { };
    let frame = 0;
    const sync = () => {
        frame = 0;
        el.style.width = `${vv.width}px`;
        el.style.height = `${vv.height}px`;
        el.style.transform = `translate3d(${vv.offsetLeft}px, ${vv.offsetTop}px, 0)`;
    };
    // resize/scroll fire continuously while the URL bar animates and while a zoomed
    // page is panned — coalesce to a single style write per frame.
    const schedule = () => {
        if (frame)
            return;
        frame = requestAnimationFrame(sync);
    };
    // Inline top/left beat the stylesheet's `inset`, so width/height/transform win.
    el.style.top = '0';
    el.style.left = '0';
    el.style.right = 'auto';
    el.style.bottom = 'auto';
    sync();
    vv.addEventListener('resize', schedule);
    vv.addEventListener('scroll', schedule);
    window.addEventListener('orientationchange', schedule);
    return () => {
        if (frame)
            cancelAnimationFrame(frame);
        vv.removeEventListener('resize', schedule);
        vv.removeEventListener('scroll', schedule);
        window.removeEventListener('orientationchange', schedule);
    };
}
/**
 * Blocks touch scrolling inside `el` from chaining out to the page behind it, while leaving
 * any scrollable region *within* `el` free to scroll normally.
 *
 * Needed on every overlay display: `overscroll-behavior: contain` only helps once a container
 * is itself scrollable and has reached its end, and older WebKit ignores it outright. Without
 * this, dragging the time wheel scrolls the page instead of the wheel.
 *
 * Returns a teardown function.
 */
function containTouchScroll(el) {
    let lastY = 0;
    const onTouchStart = (e) => {
        lastY = e.touches[0].clientY;
    };
    const onTouchMove = (e) => {
        const y = e.touches[0].clientY;
        const stepY = y - lastY;
        lastY = y;
        // Nothing inside can take this scroll — stop it reaching the page behind.
        if (e.cancelable && !absorbsScroll(e.target, el, stepY)) {
            e.preventDefault();
        }
    };
    // Must be non-passive: preventDefault() is a silent no-op on a passive listener.
    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    return () => {
        el.removeEventListener('touchstart', onTouchStart);
        el.removeEventListener('touchmove', onTouchMove);
    };
}
/**
 * Walks from `target` up to `boundary` looking for an element that can absorb a vertical
 * scroll of `dy` pixels (positive `dy` = finger moved down = content scrolls toward its top).
 *
 * Decides whether a touchmove would chain out to the page behind the overlay.
 */
function absorbsScroll(target, boundary, dy) {
    if (dy === 0)
        return true;
    let node = target instanceof Element ? target : null;
    while (node) {
        if (node instanceof HTMLElement) {
            const overflowY = getComputedStyle(node).overflowY;
            if (overflowY === 'auto' || overflowY === 'scroll') {
                // scrollHeight/clientHeight are 0 in jsdom, so this is inert under test —
                // the preventDefault path is what the tests assert on.
                const room = node.scrollHeight - node.clientHeight;
                if (room > 0) {
                    const atTop = node.scrollTop <= 0;
                    const atBottom = node.scrollTop >= room - 1;
                    if (dy > 0 && !atTop)
                        return true;
                    if (dy < 0 && !atBottom)
                        return true;
                }
            }
        }
        if (node === boundary)
            break;
        node = node.parentElement;
    }
    return false;
}

class Overlay {
    constructor(options) {
        this._cleanup = null;
        this._unbindViewport = null;
        this._el = createElement('div', 'dtp-overlay');
        this._el.style.zIndex = 'var(--dtp-z-index, 9999)';
        if (options.animate) {
            this._el.classList.add('dtp-overlay-enter');
            requestAnimationFrame(() => {
                this._el.classList.remove('dtp-overlay-enter');
                this._el.classList.add('dtp-overlay-active');
            });
        }
        else {
            this._el.classList.add('dtp-overlay-active');
        }
        const onClick = (e) => {
            if (e.target === this._el) {
                options.onClose();
            }
        };
        this._el.addEventListener('click', onClick);
        this._cleanup = () => this._el.removeEventListener('click', onClick);
        document.body.appendChild(this._el);
        // Must run after insertion — visualViewport geometry is read immediately.
        this._unbindViewport = bindVisualViewport(this._el);
    }
    getElement() {
        return this._el;
    }
    remove(animate) {
        this._cleanup?.();
        this._cleanup = null;
        this._unbindViewport?.();
        this._unbindViewport = null;
        if (animate) {
            this._el.classList.remove('dtp-overlay-active');
            this._el.classList.add('dtp-overlay-exit');
            return new Promise(resolve => {
                const onEnd = () => {
                    this._el.removeEventListener('transitionend', onEnd);
                    this._el.remove();
                    resolve();
                };
                this._el.addEventListener('transitionend', onEnd);
                // Fallback in case transition doesn't fire
                setTimeout(() => {
                    this._el.remove();
                    resolve();
                }, 400);
            });
        }
        this._el.remove();
        return Promise.resolve();
    }
}

class BottomDisplay {
    constructor() {
        this._overlay = null;
        this._wrapper = null;
        this._dragStartY = 0;
        this._dragCurrentY = 0;
        this._isDragging = false;
        this._canDismiss = false;
        this._cleanups = [];
    }
    mount(ctx) {
        this._overlay = new Overlay({ onClose: ctx.onClose, animate: true });
        this._wrapper = createElement('div', 'dtp-display dtp-display-bottom');
        this._wrapper.setAttribute('role', 'dialog');
        this._wrapper.setAttribute('aria-modal', 'true');
        this._wrapper.appendChild(ctx.content);
        this._overlay.getElement().appendChild(this._wrapper);
        // Slide-up animation
        requestAnimationFrame(() => {
            this._wrapper?.classList.add('dtp-display-bottom-active');
        });
        // Drag-to-dismiss + background scroll containment
        this._setupTouch(ctx.onClose);
        return this._wrapper;
    }
    unmount() {
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        if (this._wrapper) {
            this._wrapper.classList.remove('dtp-display-bottom-active');
        }
        this._overlay?.remove(true);
        this._overlay = null;
        this._wrapper = null;
    }
    /**
     * Drag-to-dismiss. Engages only when the sheet is already scrolled to the top and the
     * touch did not start on the wheel scroller, so it never fights the sheet's own scrolling
     * or the scroller's pointer gesture.
     *
     * Scroll containment is a separate concern, handled by `containTouchScroll` — touches on
     * the backdrop are deliberately left out of both, so the page still scrolls there.
     */
    _setupTouch(onClose) {
        if (!this._wrapper)
            return;
        const el = this._wrapper;
        const DISMISS_THRESHOLD = 100;
        const VELOCITY_THRESHOLD = 0.5;
        const DRAG_SLOP = 4;
        let lastY = 0;
        let lastTime = 0;
        let velocity = 0;
        this._cleanups.push(containTouchScroll(el));
        const inScroller = (target) => target instanceof Element && !!target.closest('.dtp-scroller');
        const onTouchStart = (e) => {
            this._dragStartY = e.touches[0].clientY;
            this._dragCurrentY = this._dragStartY;
            lastY = this._dragStartY;
            lastTime = Date.now();
            velocity = 0;
            this._isDragging = false;
            this._canDismiss = el.scrollTop <= 0 && !inScroller(e.target);
        };
        const onTouchMove = (e) => {
            const y = e.touches[0].clientY;
            const now = Date.now();
            const dt = now - lastTime;
            if (dt > 0)
                velocity = (y - lastY) / dt;
            lastY = y;
            lastTime = now;
            this._dragCurrentY = y;
            const dy = y - this._dragStartY;
            if (!this._canDismiss || dy <= DRAG_SLOP)
                return;
            if (!this._isDragging) {
                this._isDragging = true;
                el.style.transition = 'none';
            }
            el.style.transform = `translateY(${dy}px)`;
        };
        const onTouchEnd = () => {
            this._canDismiss = false;
            if (!this._isDragging)
                return;
            this._isDragging = false;
            el.style.transition = '';
            const dy = this._dragCurrentY - this._dragStartY;
            if (dy > DISMISS_THRESHOLD || velocity > VELOCITY_THRESHOLD) {
                onClose();
            }
            else {
                el.style.transform = '';
            }
        };
        el.addEventListener('touchstart', onTouchStart, { passive: true });
        el.addEventListener('touchmove', onTouchMove, { passive: true });
        el.addEventListener('touchend', onTouchEnd);
        el.addEventListener('touchcancel', onTouchEnd);
        this._cleanups.push(() => el.removeEventListener('touchstart', onTouchStart), () => el.removeEventListener('touchmove', onTouchMove), () => el.removeEventListener('touchend', onTouchEnd), () => el.removeEventListener('touchcancel', onTouchEnd));
    }
}

class CenterDisplay {
    constructor() {
        this._overlay = null;
        this._wrapper = null;
        this._releaseTouch = null;
    }
    mount(ctx) {
        this._overlay = new Overlay({ onClose: ctx.onClose, animate: true });
        this._wrapper = createElement('div', 'dtp-display dtp-display-center');
        this._wrapper.setAttribute('role', 'dialog');
        this._wrapper.setAttribute('aria-modal', 'true');
        this._wrapper.appendChild(ctx.content);
        this._overlay.getElement().appendChild(this._wrapper);
        requestAnimationFrame(() => {
            this._wrapper?.classList.add('dtp-display-center-active');
        });
        // Keep touch gestures — notably the time wheel — from scrolling the page behind.
        this._releaseTouch = containTouchScroll(this._wrapper);
        return this._wrapper;
    }
    unmount() {
        this._releaseTouch?.();
        this._releaseTouch = null;
        if (this._wrapper) {
            this._wrapper.classList.remove('dtp-display-center-active');
        }
        this._overlay?.remove(true);
        this._overlay = null;
        this._wrapper = null;
    }
}

class AnchoredDisplay {
    constructor() {
        this._wrapper = null;
        this._anchor = null;
        this._cleanups = [];
    }
    mount(ctx) {
        this._anchor = ctx.anchor;
        this._wrapper = createElement('div', 'dtp-display dtp-display-anchored');
        this._wrapper.setAttribute('role', 'dialog');
        this._wrapper.setAttribute('aria-modal', 'false');
        this._wrapper.appendChild(ctx.content);
        document.body.appendChild(this._wrapper);
        this._position();
        requestAnimationFrame(() => {
            this._wrapper?.classList.add('dtp-display-anchored-active');
        });
        // Close on click outside
        const onClickOutside = (e) => {
            if (this._wrapper &&
                !this._wrapper.contains(e.target) &&
                !ctx.anchor.contains(e.target)) {
                ctx.onClose();
            }
        };
        setTimeout(() => document.addEventListener('click', onClickOutside), 0);
        this._cleanups.push(() => document.removeEventListener('click', onClickOutside));
        // Reposition on scroll/resize
        const onReposition = () => this._position();
        window.addEventListener('scroll', onReposition, true);
        window.addEventListener('resize', onReposition);
        this._cleanups.push(() => window.removeEventListener('scroll', onReposition, true), () => window.removeEventListener('resize', onReposition));
        return this._wrapper;
    }
    unmount() {
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._wrapper?.remove();
        this._wrapper = null;
        this._anchor = null;
    }
    reposition() {
        this._position();
    }
    _position() {
        if (!this._wrapper || !this._anchor)
            return;
        const anchorRect = this._anchor.getBoundingClientRect();
        const wrapperRect = this._wrapper.getBoundingClientRect();
        const viewportH = window.innerHeight;
        const viewportW = window.innerWidth;
        const gap = 4;
        // Prefer below, flip above if not enough space
        let top = anchorRect.bottom + gap;
        if (top + wrapperRect.height > viewportH && anchorRect.top - wrapperRect.height - gap > 0) {
            top = anchorRect.top - wrapperRect.height - gap;
        }
        // Horizontal: align left edge with anchor, shift if overflowing
        let left = anchorRect.left;
        if (left + wrapperRect.width > viewportW) {
            left = viewportW - wrapperRect.width - 8;
        }
        left = Math.max(8, left);
        this._wrapper.style.position = 'fixed';
        this._wrapper.style.top = `${top}px`;
        this._wrapper.style.left = `${left}px`;
    }
}

class TopDisplay {
    constructor() {
        this._overlay = null;
        this._wrapper = null;
        this._releaseTouch = null;
    }
    mount(ctx) {
        this._overlay = new Overlay({ onClose: ctx.onClose, animate: true });
        this._wrapper = createElement('div', 'dtp-display dtp-display-top');
        this._wrapper.setAttribute('role', 'dialog');
        this._wrapper.setAttribute('aria-modal', 'true');
        this._wrapper.appendChild(ctx.content);
        this._overlay.getElement().appendChild(this._wrapper);
        requestAnimationFrame(() => {
            this._wrapper?.classList.add('dtp-display-top-active');
        });
        // CSS overscroll-behavior covers modern WebKit; this covers the rest.
        this._releaseTouch = containTouchScroll(this._wrapper);
        return this._wrapper;
    }
    unmount() {
        this._releaseTouch?.();
        this._releaseTouch = null;
        if (this._wrapper) {
            this._wrapper.classList.remove('dtp-display-top-active');
        }
        this._overlay?.remove(true);
        this._overlay = null;
        this._wrapper = null;
    }
}

class InlineDisplay {
    constructor() {
        this._wrapper = null;
    }
    mount(ctx) {
        this._wrapper = createElement('div', 'dtp-display dtp-display-inline');
        this._wrapper.appendChild(ctx.content);
        ctx.anchor.appendChild(this._wrapper);
        return this._wrapper;
    }
    unmount() {
        this._wrapper?.remove();
        this._wrapper = null;
    }
}

function createDisplay(mode) {
    switch (mode) {
        case 'bottom': return new BottomDisplay();
        case 'center': return new CenterDisplay();
        case 'anchored': return new AnchoredDisplay();
        case 'top': return new TopDisplay();
        case 'inline': return new InlineDisplay();
    }
}

function cloneDate(d) {
    return new Date(d.getTime());
}
function addMonths(d, n) {
    const r = cloneDate(d);
    r.setMonth(r.getMonth() + n);
    // Handle month overflow (e.g., Jan 31 + 1 month → Mar 3, clamp to Feb 28)
    if (r.getDate() !== d.getDate()) {
        r.setDate(0); // Go to last day of previous month
    }
    return r;
}
function isSameDay(a, b) {
    return (a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate());
}
function isBeforeDay(a, b) {
    const ay = a.getFullYear(), am = a.getMonth(), ad = a.getDate();
    const by = b.getFullYear(), bm = b.getMonth(), bd = b.getDate();
    return ay < by || (ay === by && (am < bm || (am === bm && ad < bd)));
}
function isAfterDay(a, b) {
    return isBeforeDay(b, a);
}
function isBetweenDays(d, start, end) {
    return !isBeforeDay(d, start) && !isAfterDay(d, end);
}
function getDaysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}
function getFirstDayOfMonth(year, month) {
    return new Date(year, month, 1).getDay();
}
function getISOWeekNumber(d) {
    const date = cloneDate(d);
    date.setHours(0, 0, 0, 0);
    // Set to nearest Thursday: current date + 4 - current day number (Monday=1, Sunday=7)
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    const yearStart = new Date(date.getFullYear(), 0, 1);
    return Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}
function startOfDay(d) {
    const r = cloneDate(d);
    r.setHours(0, 0, 0, 0);
    return r;
}
function startOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1);
}
function today() {
    return startOfDay(new Date());
}
function parseDate(value) {
    if (value instanceof Date)
        return cloneDate(value);
    const d = new Date(value);
    if (isNaN(d.getTime())) {
        throw new Error(`Invalid date: ${value}`);
    }
    return d;
}
function diffInMs(a, b) {
    return Math.abs(a.getTime() - b.getTime());
}
function diffInDays(a, b) {
    return Math.round(diffInMs(a, b) / 86400000);
}

const CHEVRON_LEFT$2 = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
const CHEVRON_RIGHT$2 = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
class Calendar {
    constructor(container, options) {
        this._cleanups = [];
        this._view = 'calendar';
        this._prevView = 'calendar';
        this._pickerYear = 0;
        this._yearsPage = 0;
        this._qyTab = null; // active quarter/year tab
        this._hoverDate = null;
        this._options = options;
        this._currentMonth = startOfMonth(options.month);
        this._pickerYear = this._currentMonth.getFullYear();
        this._yearsPage = this._pickerYear - (this._pickerYear % 12);
        this._el = createElement('div', 'dtp-calendar', container);
        this._render();
    }
    setMonth(d) {
        this._currentMonth = startOfMonth(d);
        this._render();
    }
    setOptions(opts) {
        Object.assign(this._options, opts);
        this._render();
    }
    getMonth() {
        return this._currentMonth;
    }
    destroy() {
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el.remove();
    }
    // --- Main render ---
    /**
     * The view actually being rendered. An active quarter/year tab overrides the
     * `calendarView` option.
     *
     * A narrow viewport degrades `year` to `quarter`: twelve mini calendars have nowhere to
     * go on a phone, and three months is the mobile maximum.
     */
    _activeView() {
        const view = this._qyTab
            ? (this._qyTab === 'year' ? 'year' : 'quarter')
            : this._options.calendarView;
        return view === 'year' && isNarrowViewport() ? 'quarter' : view;
    }
    _render() {
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el.innerHTML = '';
        // A viewport that shrank past the year view's minimum (a rotation to portrait) would
        // otherwise strand the tab as active while its button is gone from the bar.
        if (this._qyTab === 'year' && isNarrowViewport()) {
            this._qyTab = null;
        }
        const nav = this._renderNav();
        this._el.appendChild(nav);
        // Quarter/Year tab bar
        if (this._options.showQuarterYearPicker && this._view === 'calendar') {
            this._el.appendChild(this._renderQYTabBar());
        }
        const viewChanged = this._view !== this._prevView;
        if (this._view === 'calendar') {
            this._renderCalendarView(viewChanged);
            if (this._options.rangePreview) {
                this._setupRangePreview();
            }
        }
        else if (this._view === 'months') {
            this._renderMonthsView();
        }
        else if (this._view === 'years') {
            this._renderYearsView();
        }
        this._prevView = this._view;
    }
    // --- Navigation bar (adapts to current view) ---
    _renderNav() {
        const nav = createElement('div', 'dtp-calendar-nav');
        const { locale } = this._options;
        // Title button
        const titleWrap = createElement('div', 'dtp-calendar-nav-title-wrap');
        const title = createElement('button', 'dtp-calendar-nav-title');
        setAttr(title, { type: 'button', 'aria-label': 'Switch view' });
        if (this._view === 'calendar') {
            const activeView = this._activeView();
            const monthSpan = createElement('span', 'dtp-calendar-nav-title-month');
            const yearSpan = createElement('span', 'dtp-calendar-nav-title-year');
            if (activeView === 'year') {
                yearSpan.textContent = String(this._currentMonth.getFullYear());
                title.appendChild(yearSpan);
            }
            else if (activeView === 'quarter') {
                const m = this._currentMonth.getMonth();
                const qStart = m - (m % 3);
                const startName = locale.monthNames[qStart];
                const endName = locale.monthNames[qStart + 2];
                monthSpan.textContent = `${startName} – ${endName}`;
                yearSpan.textContent = ` ${this._currentMonth.getFullYear()}`;
                title.appendChild(monthSpan);
                title.appendChild(yearSpan);
            }
            else if (this._options.calendarMonths === 1) {
                monthSpan.textContent = locale.monthNames[this._currentMonth.getMonth()];
                yearSpan.textContent = ` ${this._currentMonth.getFullYear()}`;
                title.appendChild(monthSpan);
                title.appendChild(yearSpan);
            }
            else {
                const count = Math.min(this._options.calendarMonths, 3);
                const endMonth = addMonths(this._currentMonth, count - 1);
                monthSpan.textContent = `${locale.monthNamesShort[this._currentMonth.getMonth()]} – ${locale.monthNamesShort[endMonth.getMonth()]}`;
                yearSpan.textContent = ` ${endMonth.getFullYear()}`;
                title.appendChild(monthSpan);
                title.appendChild(yearSpan);
            }
        }
        else if (this._view === 'months') {
            title.textContent = String(this._pickerYear);
        }
        else {
            title.textContent = `${this._yearsPage} – ${this._yearsPage + 11}`;
        }
        const onTitleClick = (e) => {
            e.stopPropagation();
            if (this._view === 'calendar') {
                this._view = 'months';
                this._pickerYear = this._currentMonth.getFullYear();
            }
            else if (this._view === 'months') {
                this._view = 'years';
                this._yearsPage = this._pickerYear - (this._pickerYear % 12);
            }
            else {
                this._view = 'calendar';
            }
            requestAnimationFrame(() => this._render());
        };
        title.addEventListener('click', onTitleClick);
        this._cleanups.push(() => title.removeEventListener('click', onTitleClick));
        titleWrap.appendChild(title);
        // Prev / Next buttons
        const prevBtn = createElement('button', 'dtp-calendar-nav-prev');
        prevBtn.innerHTML = CHEVRON_LEFT$2;
        setAttr(prevBtn, { type: 'button' });
        const nextBtn = createElement('button', 'dtp-calendar-nav-next');
        nextBtn.innerHTML = CHEVRON_RIGHT$2;
        setAttr(nextBtn, { type: 'button' });
        if (this._view === 'calendar') {
            // Step by whatever is on screen: a quarter tab pages by 3, not by calendarMonths.
            const calView = this._activeView();
            const step = calView === 'year' ? 12 : calView === 'quarter' ? 3 : Math.min(Math.max(this._options.calendarMonths, 1), 3);
            const label = calView === 'year' ? 'year' : calView === 'quarter' ? 'quarter' : 'month';
            setAttr(prevBtn, { 'aria-label': `Previous ${label}` });
            setAttr(nextBtn, { 'aria-label': `Next ${label}` });
            const onPrev = (e) => { e.stopPropagation(); this._currentMonth = addMonths(this._currentMonth, -step); this._options.onMonthChange(this._currentMonth); this._render(); };
            const onNext = (e) => { e.stopPropagation(); this._currentMonth = addMonths(this._currentMonth, step); this._options.onMonthChange(this._currentMonth); this._render(); };
            prevBtn.addEventListener('click', onPrev);
            nextBtn.addEventListener('click', onNext);
            this._cleanups.push(() => prevBtn.removeEventListener('click', onPrev), () => nextBtn.removeEventListener('click', onNext));
        }
        else if (this._view === 'months') {
            setAttr(prevBtn, { 'aria-label': 'Previous year' });
            setAttr(nextBtn, { 'aria-label': 'Next year' });
            const onPrev = (e) => { e.stopPropagation(); this._pickerYear--; requestAnimationFrame(() => this._render()); };
            const onNext = (e) => { e.stopPropagation(); this._pickerYear++; requestAnimationFrame(() => this._render()); };
            prevBtn.addEventListener('click', onPrev);
            nextBtn.addEventListener('click', onNext);
            this._cleanups.push(() => prevBtn.removeEventListener('click', onPrev), () => nextBtn.removeEventListener('click', onNext));
        }
        else {
            setAttr(prevBtn, { 'aria-label': 'Previous years' });
            setAttr(nextBtn, { 'aria-label': 'Next years' });
            const onPrev = (e) => { e.stopPropagation(); this._yearsPage -= 12; requestAnimationFrame(() => this._render()); };
            const onNext = (e) => { e.stopPropagation(); this._yearsPage += 12; requestAnimationFrame(() => this._render()); };
            prevBtn.addEventListener('click', onPrev);
            nextBtn.addEventListener('click', onNext);
            this._cleanups.push(() => prevBtn.removeEventListener('click', onPrev), () => nextBtn.removeEventListener('click', onNext));
        }
        // Swipe (only in calendar view)
        if (this._view === 'calendar') {
            this._setupSwipe(this._el);
        }
        nav.appendChild(titleWrap);
        nav.appendChild(prevBtn);
        nav.appendChild(nextBtn);
        return nav;
    }
    // --- Quarter/Year tab bar ---
    _renderQYTabBar() {
        const bar = createElement('div', 'dtp-qy-tabbar');
        const tabs = [
            { id: 'q1', label: 'Q1' },
            { id: 'q2', label: 'Q2' },
            { id: 'q3', label: 'Q3' },
            { id: 'q4', label: 'Q4' },
        ];
        // The year view lays out twelve mini calendars — offer it only where they fit.
        if (!isNarrowViewport()) {
            tabs.push({ id: 'year', label: 'Year' });
        }
        for (const tab of tabs) {
            const btn = createElement('button', 'dtp-qy-tab');
            setAttr(btn, { type: 'button' });
            btn.textContent = tab.label;
            if (this._qyTab === tab.id) {
                addClass(btn, 'dtp-qy-tab-active');
            }
            const onClick = (e) => {
                e.stopPropagation();
                if (this._qyTab === tab.id) {
                    // Deselect — back to normal month view
                    this._qyTab = null;
                }
                else {
                    this._qyTab = tab.id;
                    // Navigate to the start of the selected quarter/year
                    if (tab.id === 'year') {
                        this._currentMonth = new Date(this._currentMonth.getFullYear(), 0, 1);
                    }
                    else {
                        const qIdx = parseInt(tab.id.charAt(1)) - 1;
                        this._currentMonth = new Date(this._currentMonth.getFullYear(), qIdx * 3, 1);
                    }
                    this._options.onMonthChange(this._currentMonth);
                }
                requestAnimationFrame(() => this._render());
            };
            btn.addEventListener('click', onClick);
            this._cleanups.push(() => btn.removeEventListener('click', onClick));
            bar.appendChild(btn);
        }
        return bar;
    }
    // --- Calendar (day grid) view ---
    _renderCalendarView(animate = false) {
        const activeView = this._activeView();
        if (activeView === 'quarter') {
            this._renderQuarterView(animate);
        }
        else if (activeView === 'year') {
            this._renderYearGridView(animate);
        }
        else {
            this._renderMonthsView_calendar(animate);
        }
    }
    _renderMonthsView_calendar(animate) {
        const { calendarMonths } = this._options;
        const count = Math.min(Math.max(calendarMonths, 1), 3);
        const grid = createElement('div', animate ? 'dtp-calendar-months dtp-view-animate' : 'dtp-calendar-months');
        for (let i = 0; i < count; i++) {
            const monthDate = addMonths(this._currentMonth, i);
            grid.appendChild(this._renderMonthGrid(monthDate));
        }
        this._el.appendChild(grid);
    }
    _renderQuarterView(animate) {
        // Show 3 months of the current quarter
        const m = this._currentMonth.getMonth();
        const quarterStart = m - (m % 3);
        const startDate = new Date(this._currentMonth.getFullYear(), quarterStart, 1);
        const grid = createElement('div', animate ? 'dtp-calendar-months dtp-view-animate' : 'dtp-calendar-months');
        for (let i = 0; i < 3; i++) {
            const monthDate = addMonths(startDate, i);
            grid.appendChild(this._renderMonthGrid(monthDate));
        }
        this._el.appendChild(grid);
    }
    _renderYearGridView(animate) {
        // Show all 12 months of the year in a 4x3 grid of mini calendars
        const year = this._currentMonth.getFullYear();
        const grid = createElement('div', animate ? 'dtp-calendar-year-grid dtp-view-animate' : 'dtp-calendar-year-grid');
        for (let m = 0; m < 12; m++) {
            const monthDate = new Date(year, m, 1);
            grid.appendChild(this._renderMonthGrid(monthDate));
        }
        this._el.appendChild(grid);
    }
    // --- Months view (4x3 month grid, replaces calendar inline) ---
    _renderMonthsView() {
        const { locale } = this._options;
        const container = createElement('div', 'dtp-picker-view');
        const grid = createElement('div', 'dtp-picker-grid');
        const currentMonth = this._currentMonth.getMonth();
        const currentYear = this._currentMonth.getFullYear();
        for (let m = 0; m < 12; m++) {
            const cell = createElement('button', 'dtp-picker-cell');
            setAttr(cell, { type: 'button' });
            cell.textContent = locale.monthNamesShort[m];
            if (m === currentMonth && this._pickerYear === currentYear) {
                addClass(cell, 'dtp-picker-cell-active');
            }
            const onMonthClick = (e) => {
                e.stopPropagation();
                this._currentMonth = new Date(this._pickerYear, m, 1);
                this._view = 'calendar';
                this._options.onMonthChange(this._currentMonth);
                requestAnimationFrame(() => this._render());
            };
            cell.addEventListener('click', onMonthClick);
            this._cleanups.push(() => cell.removeEventListener('click', onMonthClick));
            grid.appendChild(cell);
        }
        container.appendChild(grid);
        this._el.appendChild(container);
    }
    // --- Years view (4x3 year grid, replaces calendar inline) ---
    _renderYearsView() {
        const container = createElement('div', 'dtp-picker-view');
        const grid = createElement('div', 'dtp-picker-grid');
        const currentYear = this._currentMonth.getFullYear();
        for (let i = 0; i < 12; i++) {
            const year = this._yearsPage + i;
            const cell = createElement('button', 'dtp-picker-cell');
            setAttr(cell, { type: 'button' });
            cell.textContent = String(year);
            if (year === currentYear) {
                addClass(cell, 'dtp-picker-cell-active');
            }
            const onYearClick = (e) => {
                e.stopPropagation();
                this._pickerYear = year;
                this._view = 'months';
                requestAnimationFrame(() => this._render());
            };
            cell.addEventListener('click', onYearClick);
            this._cleanups.push(() => cell.removeEventListener('click', onYearClick));
            grid.appendChild(cell);
        }
        container.appendChild(grid);
        this._el.appendChild(container);
    }
    // --- Swipe support ---
    _setupSwipe(el) {
        let startX = 0;
        let startY = 0;
        const onTouchStart = (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        };
        const onTouchEnd = (e) => {
            const dx = e.changedTouches[0].clientX - startX;
            const dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
                if (dx < 0) {
                    this._currentMonth = addMonths(this._currentMonth, 1);
                }
                else {
                    this._currentMonth = addMonths(this._currentMonth, -1);
                }
                this._options.onMonthChange(this._currentMonth);
                this._render();
            }
        };
        this._el.addEventListener('touchstart', onTouchStart, { passive: true });
        this._el.addEventListener('touchend', onTouchEnd, { passive: true });
        this._cleanups.push(() => this._el.removeEventListener('touchstart', onTouchStart), () => this._el.removeEventListener('touchend', onTouchEnd));
    }
    // --- Render single month grid ---
    _renderMonthGrid(monthDate) {
        const { locale, showWeekNumbers } = this._options;
        const container = createElement('div', 'dtp-calendar-month');
        const activeView = this._activeView();
        const isMultiMonth = this._options.calendarMonths > 1 || activeView !== 'month';
        const showLabel = isMultiMonth;
        if (showLabel) {
            const label = createElement('div', 'dtp-calendar-month-label');
            label.textContent = activeView === 'year'
                ? locale.monthNamesShort[monthDate.getMonth()]
                : `${locale.monthNames[monthDate.getMonth()]} ${monthDate.getFullYear()}`;
            container.appendChild(label);
        }
        const grid = createElement('div', 'dtp-calendar-grid');
        setAttr(grid, { role: 'grid', 'aria-label': `${locale.monthNames[monthDate.getMonth()]} ${monthDate.getFullYear()}` });
        // Header row
        const headerRow = createElement('div', 'dtp-calendar-row dtp-calendar-header');
        setAttr(headerRow, { role: 'row' });
        if (showWeekNumbers) {
            headerRow.appendChild(createElement('div', 'dtp-calendar-weeknum-header'));
        }
        const firstDay = locale.firstDay;
        for (let i = 0; i < 7; i++) {
            const dayIndex = (firstDay + i) % 7;
            const cell = createElement('div', 'dtp-calendar-dayname');
            setAttr(cell, { role: 'columnheader' });
            cell.textContent = locale.dayNamesMin[dayIndex];
            if (this._options.highlightWeekends && (dayIndex === 0 || dayIndex === 6)) {
                addClass(cell, 'dtp-weekend');
            }
            headerRow.appendChild(cell);
        }
        grid.appendChild(headerRow);
        // Day cells
        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();
        const daysInMonth = getDaysInMonth(year, month);
        const firstDayOfWeek = getFirstDayOfMonth(year, month);
        const offset = (firstDayOfWeek - firstDay + 7) % 7;
        const todayDate = today();
        // Hide outer days in multi-month views to avoid duplicate days
        const showOuter = isMultiMonth ? false : this._options.showOuterDays;
        // Previous month's days for outer cells
        const prevMonthDays = getDaysInMonth(year, month - 1);
        let dayNum = 1;
        // Always 6 rows (42 cells) — gives extra week of next-month days
        const totalCells = 42;
        for (let i = 0; i < totalCells; i += 7) {
            const row = createElement('div', 'dtp-calendar-row');
            setAttr(row, { role: 'row' });
            if (showWeekNumbers) {
                // Compute actual date for this row to get correct week number
                const rowDate = new Date(year, month, 1 - offset + i);
                const wnCell = createElement('div', 'dtp-calendar-weeknum');
                wnCell.textContent = String(getISOWeekNumber(rowDate));
                row.appendChild(wnCell);
            }
            for (let j = 0; j < 7; j++) {
                const cellIndex = i + j;
                const cell = createElement('button', 'dtp-calendar-cell');
                setAttr(cell, { role: 'gridcell', type: 'button' });
                if (cellIndex < offset) {
                    // Before current month
                    const outerDay = prevMonthDays - offset + cellIndex + 1;
                    const outerDate = new Date(year, month - 1, outerDay);
                    if (showOuter) {
                        this._renderOuterCell(cell, outerDay, outerDate);
                    }
                    else {
                        addClass(cell, 'dtp-calendar-cell-empty');
                        setAttr(cell, { 'aria-hidden': 'true' });
                        cell.tabIndex = -1;
                    }
                }
                else if (dayNum > daysInMonth) {
                    // After current month
                    const outerDay = dayNum - daysInMonth;
                    const outerDate = new Date(year, month + 1, outerDay);
                    if (showOuter) {
                        this._renderOuterCell(cell, outerDay, outerDate);
                        dayNum++;
                    }
                    else {
                        addClass(cell, 'dtp-calendar-cell-empty');
                        setAttr(cell, { 'aria-hidden': 'true' });
                        cell.tabIndex = -1;
                    }
                }
                else {
                    const date = new Date(year, month, dayNum);
                    const inner = createElement('span', 'dtp-calendar-cell-inner');
                    inner.textContent = String(dayNum);
                    cell.appendChild(inner);
                    cell.dataset.date = date.toISOString();
                    if (isSameDay(date, todayDate))
                        addClass(cell, 'dtp-today');
                    if (this._options.highlightWeekends && this._isWeekend(date))
                        addClass(cell, 'dtp-weekend');
                    if (this._isSelected(date)) {
                        addClass(cell, 'dtp-selected');
                        setAttr(cell, { 'aria-selected': 'true' });
                    }
                    if (this._isInRange(date))
                        addClass(cell, 'dtp-in-range');
                    if (this._isRangeStart(date))
                        addClass(cell, 'dtp-range-start');
                    if (this._isRangeEnd(date))
                        addClass(cell, 'dtp-range-end');
                    const disabled = this._isDateDisabled(date);
                    if (disabled) {
                        addClass(cell, 'dtp-disabled');
                        setAttr(cell, { 'aria-disabled': 'true' });
                        cell.tabIndex = -1;
                    }
                    else {
                        const onClick = (e) => {
                            e.stopPropagation();
                            this._options.onSelect(date);
                        };
                        cell.addEventListener('click', onClick);
                        this._cleanups.push(() => cell.removeEventListener('click', onClick));
                    }
                    dayNum++;
                }
                row.appendChild(cell);
            }
            grid.appendChild(row);
        }
        container.appendChild(grid);
        return container;
    }
    // --- Selection helpers ---
    _isSelected(date) {
        const { value } = this._options;
        if (!value)
            return false;
        if (Array.isArray(value))
            return value.some(v => isSameDay(v, date));
        return isSameDay(value, date);
    }
    _isInRange(date) {
        if (this._options.selectMultiple)
            return false;
        const { value } = this._options;
        if (!Array.isArray(value) || value.length < 2)
            return false;
        return isBetweenDays(date, value[0], value[1]) && !isSameDay(date, value[0]) && !isSameDay(date, value[1]);
    }
    _isRangeStart(date) {
        if (this._options.selectMultiple)
            return false;
        const { value } = this._options;
        if (!Array.isArray(value) || value.length < 1)
            return false;
        return isSameDay(date, value[0]);
    }
    _isRangeEnd(date) {
        if (this._options.selectMultiple)
            return false;
        const { value } = this._options;
        if (!Array.isArray(value) || value.length < 2)
            return false;
        return isSameDay(date, value[1]);
    }
    _isWeekend(date) {
        const day = date.getDay();
        return day === 0 || day === 6;
    }
    _isDateDisabled(date) {
        const { min, max, isDisabled } = this._options;
        if (min && isBeforeDay(date, min))
            return true;
        if (max && isAfterDay(date, max))
            return true;
        return isDisabled(date);
    }
    _renderOuterCell(cell, dayNum, date) {
        const inner = createElement('span', 'dtp-calendar-cell-inner');
        inner.textContent = String(dayNum);
        cell.appendChild(inner);
        addClass(cell, 'dtp-calendar-cell-outer');
        cell.dataset.date = date.toISOString();
        if (this._options.highlightWeekends && this._isWeekend(date))
            addClass(cell, 'dtp-weekend');
        // Selection state — outer days can be selected too
        if (this._isSelected(date)) {
            addClass(cell, 'dtp-selected');
            setAttr(cell, { 'aria-selected': 'true' });
        }
        if (this._isInRange(date))
            addClass(cell, 'dtp-in-range');
        if (this._isRangeStart(date))
            addClass(cell, 'dtp-range-start');
        if (this._isRangeEnd(date))
            addClass(cell, 'dtp-range-end');
        const disabled = this._isDateDisabled(date);
        if (disabled) {
            addClass(cell, 'dtp-disabled');
            setAttr(cell, { 'aria-disabled': 'true' });
            cell.tabIndex = -1;
        }
        else {
            const onClick = (e) => {
                e.stopPropagation();
                this._options.onSelect(date);
            };
            cell.addEventListener('click', onClick);
            this._cleanups.push(() => cell.removeEventListener('click', onClick));
        }
    }
    // --- Range hover preview ---
    _setupRangePreview() {
        const onMouseOver = (e) => {
            const target = e.target.closest?.('.dtp-calendar-cell');
            if (!target?.dataset.date) {
                this._clearRangePreview();
                return;
            }
            const hoverDate = new Date(target.dataset.date);
            if (this._hoverDate && isSameDay(this._hoverDate, hoverDate))
                return;
            this._hoverDate = hoverDate;
            this._updateRangePreview();
        };
        const onMouseLeave = () => {
            this._hoverDate = null;
            this._clearRangePreview();
        };
        this._el.addEventListener('mouseover', onMouseOver);
        this._el.addEventListener('mouseleave', onMouseLeave);
        this._cleanups.push(() => this._el.removeEventListener('mouseover', onMouseOver), () => this._el.removeEventListener('mouseleave', onMouseLeave));
    }
    _updateRangePreview() {
        const { value } = this._options;
        // Only show preview when exactly 1 date selected (start picked, awaiting end)
        if (!Array.isArray(value) || value.length !== 1 || !this._hoverDate) {
            this._clearRangePreview();
            return;
        }
        const start = value[0];
        const hover = this._hoverDate;
        // Determine range direction
        const rangeStart = isBeforeDay(hover, start) ? hover : start;
        const rangeEnd = isBeforeDay(hover, start) ? start : hover;
        const cells = this._el.querySelectorAll('.dtp-calendar-cell[data-date]');
        for (const cell of cells) {
            const d = new Date(cell.dataset.date);
            cell.classList.remove('dtp-range-preview', 'dtp-range-preview-start', 'dtp-range-preview-end');
            if (isSameDay(d, rangeStart) && !isSameDay(rangeStart, rangeEnd)) {
                cell.classList.add('dtp-range-preview-start');
            }
            else if (isSameDay(d, rangeEnd) && !isSameDay(rangeStart, rangeEnd)) {
                cell.classList.add('dtp-range-preview-end');
            }
            else if (isBetweenDays(d, rangeStart, rangeEnd) && !isSameDay(d, rangeStart) && !isSameDay(d, rangeEnd)) {
                cell.classList.add('dtp-range-preview');
            }
        }
    }
    _clearRangePreview() {
        const cells = this._el.querySelectorAll('.dtp-range-preview, .dtp-range-preview-start, .dtp-range-preview-end');
        for (const cell of cells) {
            cell.classList.remove('dtp-range-preview', 'dtp-range-preview-start', 'dtp-range-preview-end');
        }
    }
}

class DateMode {
    constructor() {
        this._calendar = null;
        this._value = null;
        this._values = [];
        this._ctx = null;
        this._headerEl = null;
        this._isMulti = false;
    }
    render(container, ctx) {
        this._ctx = ctx;
        this._isMulti = ctx.options.selectMultiple === true;
        if (this._isMulti) {
            // Multi-select: value is Date[]
            if (Array.isArray(ctx.value)) {
                this._values = ctx.value.map(d => new Date(d.getTime()));
            }
            else if (ctx.value instanceof Date) {
                this._values = [new Date(ctx.value.getTime())];
            }
            else {
                this._values = [];
            }
            // Counter header
            this._headerEl = createElement('div', 'dtp-multi-select-header', container);
            this._updateHeader();
        }
        else {
            this._value = ctx.value instanceof Date ? ctx.value : null;
        }
        this._calendar = new Calendar(container, {
            locale: ctx.locale,
            month: (this._isMulti ? this._values[0] : this._value) || today(),
            value: this._isMulti ? this._values : this._value,
            min: ctx.options.min,
            max: ctx.options.max,
            calendarMonths: ctx.options.calendarMonths,
            calendarView: ctx.options.calendarView,
            showQuarterYearPicker: ctx.options.showQuarterYearPicker,
            showOuterDays: ctx.options.showOuterDays,
            showWeekNumbers: ctx.options.showWeekNumbers,
            highlightWeekends: ctx.options.highlightWeekends,
            selectMultiple: this._isMulti,
            rangePreview: false,
            isDisabled: ctx.isDisabled,
            onSelect: (date) => this._handleSelect(date),
            onMonthChange: () => { },
        });
    }
    _handleSelect(date) {
        if (this._isMulti) {
            const idx = this._values.findIndex(v => isSameDay(v, date));
            if (idx >= 0) {
                // Deselect
                this._values.splice(idx, 1);
            }
            else {
                // Check max limit
                const max = this._ctx?.options.selectMax;
                if (max != null && this._values.length >= max)
                    return;
                this._values.push(date);
            }
            // Sort chronologically
            this._values.sort((a, b) => a.getTime() - b.getTime());
            const val = this._values.length > 0 ? [...this._values] : null;
            this._ctx?.onValueChange(val);
            this._updateHeader();
            requestAnimationFrame(() => {
                this._calendar?.setOptions({ value: val });
            });
        }
        else {
            this._value = date;
            this._ctx?.onValueChange(date);
            requestAnimationFrame(() => {
                this._calendar?.setOptions({ value: date });
            });
        }
    }
    _updateHeader() {
        if (!this._headerEl || !this._ctx)
            return;
        const count = this._values.length;
        const max = this._ctx.options.selectMax;
        const locale = this._ctx.locale;
        if (max != null) {
            this._headerEl.textContent = `${count} ${locale.ofText} ${max} ${locale.selectedText}`;
        }
        else {
            this._headerEl.textContent = `${count} ${locale.selectedText}`;
        }
    }
    destroy() {
        this._calendar?.destroy();
        this._calendar = null;
        this._headerEl?.remove();
        this._headerEl = null;
    }
    getValue() {
        if (this._isMulti) {
            return this._values.length > 0 ? [...this._values] : null;
        }
        return this._value;
    }
}

const ITEM_HEIGHT = 36;
const VISIBLE_ITEMS = 5;
const DECELERATION = 0.96;
const MIN_VELOCITY = 0.3;
const SCROLLER_HEIGHT = ITEM_HEIGHT * VISIBLE_ITEMS;
class Scroller {
    constructor(container, options) {
        this._columns = [];
        this._options = options;
        this._el = createElement('div', 'dtp-scroller', container);
        this._el.style.height = SCROLLER_HEIGHT + 'px';
        this._render();
    }
    setOptions(opts) {
        Object.assign(this._options, opts);
        this._render();
    }
    destroy() {
        this._columns.forEach(c => c.destroy());
        this._columns = [];
        this._el.remove();
    }
    _render() {
        this._columns.forEach(c => c.destroy());
        this._columns = [];
        this._el.innerHTML = '';
        // Selection indicator — positioned via JS to guarantee alignment with item math
        const indicator = createElement('div', 'dtp-scroller-indicator');
        const indicatorTop = Math.floor(VISIBLE_ITEMS / 2) * ITEM_HEIGHT;
        indicator.style.top = indicatorTop + 'px';
        indicator.style.height = ITEM_HEIGHT + 'px';
        this._el.appendChild(indicator);
        for (let i = 0; i < this._options.columns.length; i++) {
            const col = new ScrollerColumnInstance(this._el, this._options.columns[i], i, this._options.onSelect);
            this._columns.push(col);
        }
    }
}
class ScrollerColumnInstance {
    constructor(container, column, index, onSelect) {
        this._offset = 0;
        this._velocity = 0;
        this._tracking = false;
        this._lastY = 0;
        this._lastTime = 0;
        this._animFrame = 0;
        this._cleanups = [];
        this._column = column;
        this._index = index;
        this._onSelect = onSelect;
        this._el = createElement('div', 'dtp-scroller-column', container);
        this._wrapper = createElement('div', 'dtp-scroller-wrapper', this._el);
        this._renderItems();
        this._scrollToSelected(false);
        this._bindEvents();
    }
    destroy() {
        cancelAnimationFrame(this._animFrame);
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el.remove();
    }
    _renderItems() {
        const padding = Math.floor(VISIBLE_ITEMS / 2);
        for (let i = 0; i < padding; i++) {
            createElement('div', 'dtp-scroller-item dtp-scroller-padding', this._wrapper);
        }
        for (const item of this._column.values) {
            const el = createElement('div', 'dtp-scroller-item', this._wrapper);
            el.textContent = item.label;
            el.dataset.value = String(item.value);
        }
        for (let i = 0; i < padding; i++) {
            createElement('div', 'dtp-scroller-item dtp-scroller-padding', this._wrapper);
        }
    }
    _scrollToSelected(animate) {
        let idx = this._column.values.findIndex(v => v.value === this._column.selected);
        // If exact match fails, try loose comparison (number/string mismatch)
        if (idx === -1) {
            idx = this._column.values.findIndex(v => String(v.value) === String(this._column.selected));
        }
        // Default to first item if still not found
        if (idx === -1)
            idx = 0;
        const targetOffset = -idx * ITEM_HEIGHT;
        if (animate) {
            this._animateTo(targetOffset);
        }
        else {
            this._offset = targetOffset;
            this._applyTransform();
        }
    }
    _bindEvents() {
        let startY = 0;
        let isDragging = false;
        // Unified pointer handling (mouse + touch)
        const onPointerDown = (e) => {
            isDragging = true;
            this._tracking = true;
            this._velocity = 0;
            cancelAnimationFrame(this._animFrame);
            startY = e.clientY;
            this._lastY = e.clientY;
            this._lastTime = Date.now();
            this._el.setPointerCapture(e.pointerId);
            e.preventDefault();
        };
        const onPointerMove = (e) => {
            if (!isDragging)
                return;
            const y = e.clientY;
            const now = Date.now();
            const dt = now - this._lastTime;
            const dy = y - this._lastY;
            if (dt > 0) {
                this._velocity = dy / dt * 16;
            }
            this._offset += dy;
            this._clampOffset();
            this._applyTransform();
            this._lastY = y;
            this._lastTime = now;
            e.preventDefault();
        };
        const onPointerUp = (e) => {
            if (!isDragging)
                return;
            isDragging = false;
            this._tracking = false;
            const totalDrag = Math.abs(e.clientY - startY);
            // If barely moved, treat as a click — find the item under the pointer
            if (totalDrag < 5) {
                const rect = this._el.getBoundingClientRect();
                const clickY = e.clientY - rect.top;
                // Indicator center is at padding * ITEM_HEIGHT + ITEM_HEIGHT/2
                const padding = Math.floor(VISIBLE_ITEMS / 2);
                const indicatorCenter = padding * ITEM_HEIGHT + ITEM_HEIGHT / 2;
                // How many items away from center was the click?
                const clickOffset = Math.round((clickY - indicatorCenter) / ITEM_HEIGHT);
                const currentIdx = Math.round(-this._offset / ITEM_HEIGHT);
                const targetIdx = Math.max(0, Math.min(currentIdx + clickOffset, this._column.values.length - 1));
                this._animateTo(-targetIdx * ITEM_HEIGHT, () => this._emitSelect(targetIdx));
                return;
            }
            if (Math.abs(this._velocity) > MIN_VELOCITY) {
                this._momentum();
            }
            else {
                this._snapToNearest();
            }
        };
        // Mouse wheel
        const onWheel = (e) => {
            e.preventDefault();
            cancelAnimationFrame(this._animFrame);
            // Scroll by one item per wheel tick
            const direction = e.deltaY > 0 ? 1 : -1;
            const currentIdx = Math.round(-this._offset / ITEM_HEIGHT);
            const targetIdx = Math.max(0, Math.min(currentIdx + direction, this._column.values.length - 1));
            this._animateTo(-targetIdx * ITEM_HEIGHT, () => this._emitSelect(targetIdx));
        };
        this._el.addEventListener('pointerdown', onPointerDown);
        this._el.addEventListener('pointermove', onPointerMove);
        this._el.addEventListener('pointerup', onPointerUp);
        this._el.addEventListener('pointercancel', onPointerUp);
        this._el.addEventListener('wheel', onWheel, { passive: false });
        // Prevent text selection while dragging
        const onSelectStart = (e) => { if (isDragging)
            e.preventDefault(); };
        this._el.addEventListener('selectstart', onSelectStart);
        this._cleanups.push(() => this._el.removeEventListener('pointerdown', onPointerDown), () => this._el.removeEventListener('pointermove', onPointerMove), () => this._el.removeEventListener('pointerup', onPointerUp), () => this._el.removeEventListener('pointercancel', onPointerUp), () => this._el.removeEventListener('wheel', onWheel), () => this._el.removeEventListener('selectstart', onSelectStart));
    }
    _emitSelect(idx) {
        const val = this._column.values[idx];
        if (val) {
            this._column.selected = val.value;
            this._onSelect(this._index, val.value);
            this._updateSelectedStyle();
        }
    }
    _momentum() {
        this._velocity *= DECELERATION;
        if (Math.abs(this._velocity) < MIN_VELOCITY) {
            this._snapToNearest();
            return;
        }
        this._offset += this._velocity;
        this._clampOffset();
        this._applyTransform();
        this._animFrame = requestAnimationFrame(() => this._momentum());
    }
    _snapToNearest() {
        const idx = Math.round(-this._offset / ITEM_HEIGHT);
        const clamped = Math.max(0, Math.min(idx, this._column.values.length - 1));
        this._animateTo(-clamped * ITEM_HEIGHT, () => this._emitSelect(clamped));
    }
    _animateTo(target, done) {
        const start = this._offset;
        const distance = target - start;
        if (Math.abs(distance) < 0.5) {
            this._offset = target;
            this._applyTransform();
            done?.();
            return;
        }
        const duration = Math.min(300, Math.abs(distance) * 3);
        const startTime = Date.now();
        const step = () => {
            const elapsed = Date.now() - startTime;
            const t = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            this._offset = start + distance * eased;
            this._applyTransform();
            if (t < 1) {
                this._animFrame = requestAnimationFrame(step);
            }
            else {
                done?.();
            }
        };
        cancelAnimationFrame(this._animFrame);
        this._animFrame = requestAnimationFrame(step);
    }
    _clampOffset() {
        const maxOffset = 0;
        const minOffset = -(this._column.values.length - 1) * ITEM_HEIGHT;
        this._offset = Math.max(minOffset, Math.min(maxOffset, this._offset));
    }
    _applyTransform() {
        // The wrapper has padding items that naturally center item 0 at the indicator.
        // offset=0 → item 0 at center. offset=-ITEM_HEIGHT → item 1 at center. etc.
        // No extra shift needed — the padding items handle it.
        this._wrapper.style.transform = `translate3d(0, ${this._offset}px, 0)`;
        this._updateItemStyles();
    }
    _updateItemStyles() {
        const items = this._wrapper.querySelectorAll('.dtp-scroller-item:not(.dtp-scroller-padding)');
        const selectedIdx = Math.max(0, Math.min(Math.round(-this._offset / ITEM_HEIGHT), this._column.values.length - 1));
        // The indicator center is at padding * ITEM_HEIGHT + ITEM_HEIGHT/2 from wrapper top
        // Each data item i has its center at (padding + i) * ITEM_HEIGHT + ITEM_HEIGHT/2 from wrapper top
        // On screen (after transform), item i center = (padding + i) * ITEM_HEIGHT + ITEM_HEIGHT/2 + offset
        // The indicator center on screen = padding * ITEM_HEIGHT + ITEM_HEIGHT/2 (fixed, no transform)
        // Distance from center = |i * ITEM_HEIGHT + offset|
        items.forEach((item, i) => {
            const distFromCenter = Math.abs(i * ITEM_HEIGHT + this._offset);
            const maxDist = VISIBLE_ITEMS / 2 * ITEM_HEIGHT;
            const opacity = Math.max(0, 1 - distFromCenter / maxDist);
            item.style.opacity = String(Math.max(0.05, opacity));
            if (i === selectedIdx) {
                item.classList.add('dtp-scroller-selected');
            }
            else {
                item.classList.remove('dtp-scroller-selected');
            }
        });
    }
    _updateSelectedStyle() {
        const items = this._wrapper.querySelectorAll('.dtp-scroller-item:not(.dtp-scroller-padding)');
        const selectedIdx = Math.round(-this._offset / ITEM_HEIGHT);
        items.forEach((item, i) => {
            if (i === selectedIdx) {
                item.classList.add('dtp-scroller-selected');
            }
            else {
                item.classList.remove('dtp-scroller-selected');
            }
        });
    }
}

class TimeMode {
    constructor() {
        this._scroller = null;
        this._hours = 0;
        this._minutes = 0;
        this._ctx = null;
        this._is24h = true;
    }
    render(container, ctx) {
        this._ctx = ctx;
        const now = ctx.value instanceof Date ? ctx.value : new Date();
        // Snap to nearest valid step values
        const stepH = ctx.options.stepHour;
        const stepM = ctx.options.stepMinute;
        this._hours = Math.round(now.getHours() / stepH) * stepH;
        this._minutes = Math.round(now.getMinutes() / stepM) * stepM;
        if (this._minutes >= 60)
            this._minutes = 60 - stepM;
        if (this._hours >= 24)
            this._hours = 24 - stepH;
        // Enforce min constraints (snap up if needed)
        this._snapToMin(stepH, stepM);
        const effectiveTimeFormat = ctx.options.timeFormat || ctx.locale.timeFormat;
        this._is24h = effectiveTimeFormat.includes('H');
        const columns = this._buildColumns();
        this._scroller = new Scroller(container, {
            columns,
            onSelect: (colIndex, value) => {
                const prevHours = this._hours;
                if (this._is24h) {
                    if (colIndex === 0)
                        this._hours = value;
                    if (colIndex === 1)
                        this._minutes = value;
                }
                else {
                    if (colIndex === 0) {
                        let h = value;
                        if (this._hours >= 12)
                            h = h === 12 ? 12 : h + 12;
                        else
                            h = h === 12 ? 0 : h;
                        this._hours = h;
                    }
                    if (colIndex === 1)
                        this._minutes = value;
                    if (colIndex === 2) {
                        const isPM = value === 'PM';
                        if (isPM && this._hours < 12)
                            this._hours += 12;
                        if (!isPM && this._hours >= 12)
                            this._hours -= 12;
                    }
                }
                // When hour or AM/PM changed and min constraints active, update columns
                const hasMinConstraint = ctx.options._minHour != null;
                const hourChanged = this._hours !== prevHours;
                if (hasMinConstraint && hourChanged) {
                    this._snapToMin(stepH, stepM);
                    // Rebuild scroller so minute column reflects new constraints
                    requestAnimationFrame(() => {
                        this._scroller?.setOptions({ columns: this._buildColumns() });
                    });
                }
                ctx.onValueChange(this._buildDate());
            },
        });
    }
    destroy() {
        this._scroller?.destroy();
        this._scroller = null;
    }
    getValue() {
        return this._buildDate();
    }
    _snapToMin(stepH, stepM) {
        if (!this._ctx)
            return;
        const minH = this._ctx.options._minHour;
        const minM = this._ctx.options._minMinute;
        if (minH != null) {
            if (this._hours < minH) {
                this._hours = minH;
                this._minutes = minM != null ? Math.ceil(minM / stepM) * stepM : 0;
                if (this._minutes >= 60) {
                    this._minutes = 0;
                    this._hours = Math.min(this._hours + stepH, 23);
                }
            }
            else if (this._hours === minH && minM != null && this._minutes < minM) {
                this._minutes = Math.ceil(minM / stepM) * stepM;
                if (this._minutes >= 60) {
                    this._minutes = 0;
                    this._hours = Math.min(this._hours + stepH, 23);
                }
            }
        }
    }
    _buildDate() {
        const d = new Date();
        d.setHours(this._hours, this._minutes, 0, 0);
        return d;
    }
    _buildColumns() {
        if (!this._ctx)
            return [];
        const { stepHour, stepMinute } = this._ctx.options;
        const minH = this._ctx.options._minHour;
        const minM = this._ctx.options._minMinute;
        const columns = [];
        // Hours
        const hourValues = [];
        if (this._is24h) {
            for (let h = 0; h < 24; h += stepHour) {
                if (minH != null && h < minH)
                    continue;
                hourValues.push({ value: h, label: String(h).padStart(2, '0') });
            }
            columns.push({ values: hourValues, selected: this._hours });
        }
        else {
            // 12h: filter hours based on min constraint + current AM/PM
            const isPM = this._hours >= 12;
            for (let h = 1; h <= 12; h += stepHour) {
                if (minH != null) {
                    const actual = isPM ? (h === 12 ? 12 : h + 12) : (h === 12 ? 0 : h);
                    if (actual < minH)
                        continue;
                }
                hourValues.push({ value: h, label: String(h) });
            }
            const display12 = this._hours % 12 || 12;
            columns.push({ values: hourValues, selected: display12 });
        }
        // Minutes — only show minutes >= minM when on the min hour
        const minuteValues = [];
        for (let m = 0; m < 60; m += stepMinute) {
            if (minH != null && minM != null && this._hours === minH && m < minM)
                continue;
            minuteValues.push({ value: m, label: String(m).padStart(2, '0') });
        }
        if (minuteValues.length === 0) {
            minuteValues.push({ value: 0, label: '00' });
        }
        columns.push({ values: minuteValues, selected: this._minutes });
        // AM/PM — hide AM if all AM hours are below min
        if (!this._is24h) {
            const ampmValues = [];
            if (minH == null || minH < 12) {
                ampmValues.push({ value: 'AM', label: 'AM' });
            }
            ampmValues.push({ value: 'PM', label: 'PM' });
            columns.push({
                values: ampmValues,
                selected: this._hours >= 12 ? 'PM' : 'AM',
            });
        }
        return columns;
    }
}

class DateTimeMode {
    constructor() {
        this._dateMode = null;
        this._timeMode = null;
        this._value = new Date();
    }
    render(container, ctx) {
        const now = ctx.value instanceof Date ? ctx.value : new Date();
        this._value = new Date(now.getTime());
        // Horizontal layout wrapper: calendar left, time right
        const wrapper = createElement('div', 'dtp-mode-datetime-layout', container);
        const dateSection = createElement('div', 'dtp-mode-datetime-date', wrapper);
        const timeSection = createElement('div', 'dtp-mode-datetime-time', wrapper);
        this._dateMode = new DateMode();
        this._dateMode.render(dateSection, {
            ...ctx,
            value: this._value,
            onValueChange: (d) => {
                if (d instanceof Date) {
                    this._value.setFullYear(d.getFullYear(), d.getMonth(), d.getDate());
                    ctx.onValueChange(new Date(this._value.getTime()));
                }
            },
        });
        this._timeMode = new TimeMode();
        this._timeMode.render(timeSection, {
            ...ctx,
            value: this._value,
            onValueChange: (d) => {
                if (d instanceof Date) {
                    this._value.setHours(d.getHours(), d.getMinutes(), 0, 0);
                    ctx.onValueChange(new Date(this._value.getTime()));
                }
            },
        });
    }
    destroy() {
        this._dateMode?.destroy();
        this._timeMode?.destroy();
        this._dateMode = null;
        this._timeMode = null;
    }
    getValue() {
        return new Date(this._value.getTime());
    }
}

const TOKEN_RE = /yyyy|yy|mm|m|dd|d|HH|H|hh|h|MM|M|ss|s|A|a/g;
function pad(n) {
    return n < 10 ? '0' + n : String(n);
}
function get12Hour(h) {
    return h % 12 || 12;
}
function getAmPm(h, upper) {
    const s = h < 12 ? 'am' : 'pm';
    return upper ? s.toUpperCase() : s;
}
function formatDate(date, format, locale) {
    return format.replace(TOKEN_RE, (token) => {
        switch (token) {
            case 'yyyy': return String(date.getFullYear());
            case 'yy': return String(date.getFullYear()).slice(-2);
            case 'mm': return pad(date.getMonth() + 1);
            case 'm': return String(date.getMonth() + 1);
            case 'dd': return pad(date.getDate());
            case 'd': return String(date.getDate());
            case 'HH': return pad(date.getHours());
            case 'H': return String(date.getHours());
            case 'hh': return pad(get12Hour(date.getHours()));
            case 'h': return String(get12Hour(date.getHours()));
            case 'MM': return pad(date.getMinutes());
            case 'M': return String(date.getMinutes());
            case 'ss': return pad(date.getSeconds());
            case 's': return String(date.getSeconds());
            case 'A': return getAmPm(date.getHours(), true);
            case 'a': return getAmPm(date.getHours(), false);
            default: return token;
        }
    });
}
function formatDateWithLocale(date, locale, mode = 'date', overrides) {
    if (mode === 'month') {
        return `${locale.monthNames[date.getMonth()]} ${date.getFullYear()}`;
    }
    if (mode === 'year') {
        return String(date.getFullYear());
    }
    let fmt;
    if (mode === 'time') {
        fmt = overrides?.timeFormat || locale.timeFormat;
    }
    else if (mode === 'datetime') {
        // Build datetime from overridden parts or locale default
        const df = overrides?.dateFormat || locale.dateFormat;
        const tf = overrides?.timeFormat || locale.timeFormat;
        fmt = `${df} ${tf}`;
    }
    else {
        fmt = overrides?.dateFormat || locale.dateFormat;
    }
    return formatDate(date, fmt);
}
function formatRange(start, end, locale, mode = 'date', overrides) {
    const s = formatDateWithLocale(start, locale, mode, overrides);
    const e = formatDateWithLocale(end, locale, mode, overrides);
    return `${s} – ${e}`;
}

/**
 * Preset pills shown inline on a narrow viewport, as a 3-column grid — two rows.
 * Beyond this the last slot becomes a "show all" button opening the full panel.
 */
const MOBILE_PRESET_SLOTS = 6;
class DateRangeMode {
    constructor() {
        this._calendar = null;
        this._start = null;
        this._end = null;
        this._selectingEnd = false;
        this._ctx = null;
        this._labelsEl = null;
        this._pillEl = null;
        this._startLabelEl = null;
        this._endLabelEl = null;
        this._startValueEl = null;
        this._endValueEl = null;
        this._presetsEl = null;
        this._layoutEl = null;
        this._panelEl = null;
        this._moreBtn = null;
        /** Every preset pill across the inline grid and the panel, paired with its preset index. */
        this._presetButtons = [];
    }
    render(container, ctx) {
        this._ctx = ctx;
        if (Array.isArray(ctx.value) && ctx.value.length >= 2) {
            this._start = ctx.value[0];
            this._end = ctx.value[1];
            this._selectingEnd = false;
        }
        // Range labels — always shown
        const labels = ctx.options.labels;
        this._labelsEl = createElement('div', 'dtp-range-labels', container);
        // Sliding pill background
        this._pillEl = createElement('div', 'dtp-range-labels-pill');
        this._labelsEl.appendChild(this._pillEl);
        // Start label
        this._startLabelEl = createElement('div', 'dtp-range-label dtp-range-label-start');
        const startTitle = createElement('div', 'dtp-range-label-title');
        startTitle.textContent = labels.start || 'Start';
        this._startValueEl = createElement('div', 'dtp-range-label-value');
        this._startLabelEl.appendChild(startTitle);
        this._startLabelEl.appendChild(this._startValueEl);
        // Click to switch to selecting start
        const onStartClick = (e) => {
            e.stopPropagation();
            this._selectingEnd = false;
            this._updateLabels();
        };
        this._startLabelEl.addEventListener('click', onStartClick);
        // End label
        this._endLabelEl = createElement('div', 'dtp-range-label dtp-range-label-end');
        const endTitle = createElement('div', 'dtp-range-label-title');
        endTitle.textContent = labels.end || 'End';
        this._endValueEl = createElement('div', 'dtp-range-label-value');
        this._endLabelEl.appendChild(endTitle);
        this._endLabelEl.appendChild(this._endValueEl);
        // Click to switch to selecting end
        const onEndClick = (e) => {
            e.stopPropagation();
            if (this._start) {
                this._selectingEnd = true;
                this._updateLabels();
            }
        };
        this._endLabelEl.addEventListener('click', onEndClick);
        this._labelsEl.appendChild(this._startLabelEl);
        this._labelsEl.appendChild(this._endLabelEl);
        this._updateLabels();
        // Presets + calendar layout
        const hasPresets = ctx.options.presets && ctx.options.presets.length > 0;
        const layoutEl = hasPresets
            ? createElement('div', 'dtp-range-layout', container)
            : container;
        this._layoutEl = hasPresets ? layoutEl : null;
        if (hasPresets) {
            this._renderPresets(layoutEl, ctx.options.presets);
        }
        const calendarContainer = hasPresets
            ? createElement('div', 'dtp-range-calendar-wrap', layoutEl)
            : container;
        // Panel lives after the calendar so it can take its place when opened.
        if (hasPresets && this._moreBtn) {
            this._renderPresetPanel(layoutEl, ctx.options.presets);
        }
        this._calendar = new Calendar(calendarContainer, {
            locale: ctx.locale,
            month: this._start || today(),
            value: this._getRangeValue(),
            min: ctx.options.min,
            max: ctx.options.max,
            calendarMonths: ctx.options.calendarMonths,
            calendarView: ctx.options.calendarView,
            showQuarterYearPicker: ctx.options.showQuarterYearPicker,
            showOuterDays: ctx.options.showOuterDays,
            showWeekNumbers: ctx.options.showWeekNumbers,
            highlightWeekends: ctx.options.highlightWeekends,
            selectMultiple: false,
            rangePreview: true,
            isDisabled: (date) => this._isDateDisabled(date),
            onSelect: (date) => this._handleSelect(date),
            onMonthChange: () => { },
        });
    }
    destroy() {
        this._calendar?.destroy();
        this._calendar = null;
        this._labelsEl?.remove();
        this._labelsEl = null;
        this._presetsEl = null;
        this._layoutEl = null;
        this._panelEl = null;
        this._moreBtn = null;
        this._presetButtons = [];
    }
    // --- Presets ---
    /**
     * Inline preset strip. Desktop lists every preset in the side panel, as before.
     *
     * A narrow viewport gets a fixed grid of pills instead: the old horizontal scroll strip
     * put everything past the second preset off-screen with no affordance suggesting it was
     * there. Once the presets outnumber the slots, the last slot becomes a button opening the
     * full set rather than silently dropping the overflow.
     */
    _renderPresets(layoutEl, presets) {
        this._presetsEl = createElement('div', 'dtp-range-presets', layoutEl);
        const overflows = isNarrowViewport() && presets.length > MOBILE_PRESET_SLOTS;
        const inlineCount = overflows ? MOBILE_PRESET_SLOTS - 1 : presets.length;
        for (let i = 0; i < inlineCount; i++) {
            this._presetsEl.appendChild(this._createPresetButton(presets[i], i));
        }
        if (overflows) {
            this._moreBtn = this._createMoreButton(presets.length - inlineCount);
            this._presetsEl.appendChild(this._moreBtn);
        }
    }
    /** Full-set panel that takes the calendar's place while open. */
    _renderPresetPanel(layoutEl, presets) {
        this._panelEl = createElement('div', 'dtp-range-presets-panel', layoutEl);
        const head = createElement('div', 'dtp-range-presets-panel-head', this._panelEl);
        const closeBtn = createElement('button', 'dtp-range-presets-close', head);
        setAttr(closeBtn, { type: 'button', 'aria-label': 'Close presets' });
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this._setPanelOpen(false);
        });
        const grid = createElement('div', 'dtp-range-presets-panel-grid', this._panelEl);
        for (let i = 0; i < presets.length; i++) {
            // Picking from the panel returns to the calendar, so the applied range is visible.
            grid.appendChild(this._createPresetButton(presets[i], i, () => this._setPanelOpen(false)));
        }
    }
    _createPresetButton(preset, index, onPicked) {
        const btn = createElement('button', 'dtp-range-preset');
        setAttr(btn, { type: 'button' });
        btn.textContent = preset.label;
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this._applyPreset(preset);
            onPicked?.();
        });
        this._presetButtons.push({ el: btn, presetIndex: index });
        return btn;
    }
    /** Language-neutral label, matching the English-only aria text used elsewhere in the UI. */
    _createMoreButton(hiddenCount) {
        const btn = createElement('button', 'dtp-range-preset dtp-range-preset-more');
        setAttr(btn, {
            type: 'button',
            'aria-expanded': 'false',
            'aria-label': `Show all presets (${hiddenCount} more)`,
        });
        btn.textContent = `+${hiddenCount}`;
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this._setPanelOpen(true);
        });
        return btn;
    }
    _setPanelOpen(open) {
        if (!this._layoutEl)
            return;
        this._layoutEl.classList.toggle('dtp-range-presets-open', open);
        this._moreBtn?.setAttribute('aria-expanded', String(open));
        const focusTarget = open
            ? this._panelEl?.querySelector('.dtp-range-presets-close')
            : this._moreBtn;
        requestAnimationFrame(() => focusTarget?.focus());
    }
    _applyPreset(preset) {
        const [s, e] = typeof preset.value === 'function' ? preset.value() : preset.value;
        this._start = new Date(s.getTime());
        this._end = new Date(e.getTime());
        this._selectingEnd = false;
        this._updateLabels();
        this._updatePresetActive();
        this._ctx?.onValueChange(this.getValue());
        requestAnimationFrame(() => {
            this._calendar?.setOptions({
                value: this._getRangeValue(),
                month: this._start,
            });
        });
    }
    getValue() {
        if (this._start && this._end)
            return [this._start, this._end];
        if (this._start)
            return [this._start];
        return null;
    }
    _handleSelect(date) {
        if (!this._start || this._selectingEnd === false) {
            // Selecting start
            this._start = date;
            this._end = null;
            this._selectingEnd = true;
        }
        else {
            // Selecting end
            if (isAfterDay(this._start, date) || isSameDay(this._start, date)) {
                // If end is before start, swap
                this._end = this._start;
                this._start = date;
            }
            else {
                this._end = date;
            }
            this._selectingEnd = false;
        }
        this._updateLabels();
        this._updatePresetActive();
        this._ctx?.onValueChange(this.getValue());
        // Defer re-render so the clicked element isn't destroyed mid-event
        requestAnimationFrame(() => {
            this._calendar?.setOptions({ value: this._getRangeValue() });
        });
    }
    _updateLabels() {
        if (!this._startLabelEl || !this._endLabelEl || !this._ctx)
            return;
        // Slide pill to active side
        if (this._pillEl) {
            if (this._selectingEnd) {
                this._pillEl.classList.add('dtp-range-pill-end');
            }
            else {
                this._pillEl.classList.remove('dtp-range-pill-end');
            }
        }
        // Active state
        if (this._selectingEnd) {
            this._startLabelEl.classList.remove('dtp-range-label-active');
            this._endLabelEl.classList.add('dtp-range-label-active');
        }
        else {
            this._startLabelEl.classList.add('dtp-range-label-active');
            this._endLabelEl.classList.remove('dtp-range-label-active');
        }
        // Values
        const locale = this._ctx.locale;
        if (this._startValueEl) {
            if (this._start) {
                this._startValueEl.textContent = formatDateWithLocale(this._start, locale, 'date');
                this._startValueEl.classList.remove('dtp-range-label-value-empty');
            }
            else {
                this._startValueEl.textContent = 'Select';
                this._startValueEl.classList.add('dtp-range-label-value-empty');
            }
        }
        if (this._endValueEl) {
            if (this._end) {
                this._endValueEl.textContent = formatDateWithLocale(this._end, locale, 'date');
                this._endValueEl.classList.remove('dtp-range-label-value-empty');
            }
            else {
                this._endValueEl.textContent = 'Select';
                this._endValueEl.classList.add('dtp-range-label-value-empty');
            }
        }
    }
    /**
     * Drives active state off the registry rather than DOM order: the same preset can appear
     * twice (inline grid and panel), and the "+N" button shares the pill class without
     * belonging to any preset.
     */
    _updatePresetActive() {
        const presets = this._ctx?.options.presets;
        if (!presets)
            return;
        for (const { el, presetIndex } of this._presetButtons) {
            const preset = presets[presetIndex];
            if (!preset)
                continue;
            const [s, e] = typeof preset.value === 'function' ? preset.value() : preset.value;
            const match = this._start && this._end && isSameDay(this._start, s) && isSameDay(this._end, e);
            el.classList.toggle('dtp-range-preset-active', !!match);
        }
    }
    _isDateDisabled(date) {
        if (!this._ctx)
            return false;
        // Base disabled check
        if (this._ctx.isDisabled(date))
            return true;
        // Range constraints only apply when selecting end
        if (!this._selectingEnd || !this._start)
            return false;
        const { minRange, maxRange } = this._ctx.options;
        const days = diffInDays(date, this._start);
        if (minRange != null && days < minRange && !isSameDay(date, this._start))
            return true;
        if (maxRange != null && days > maxRange)
            return true;
        return false;
    }
    _getRangeValue() {
        if (this._start && this._end)
            return [this._start, this._end];
        if (this._start)
            return [this._start];
        return null;
    }
}

class DateTimeRangeMode {
    constructor() {
        this._calendar = null;
        this._time = null;
        this._selectingEnd = false;
        this._ctx = null;
        // DOM refs
        this._pillEl = null;
        this._startLabelEl = null;
        this._endLabelEl = null;
        this._startValueEl = null;
        this._endValueEl = null;
        this._labelsEl = null;
        this._timeContainer = null;
        this._start = new Date();
        this._end = new Date();
    }
    render(container, ctx) {
        this._ctx = ctx;
        if (Array.isArray(ctx.value) && ctx.value.length >= 2) {
            this._start = new Date(ctx.value[0].getTime());
            this._end = new Date(ctx.value[1].getTime());
        }
        // --- Pill labels ---
        const labels = ctx.options.labels;
        this._labelsEl = createElement('div', 'dtp-range-labels', container);
        this._pillEl = createElement('div', 'dtp-range-labels-pill');
        this._labelsEl.appendChild(this._pillEl);
        this._startLabelEl = createElement('div', 'dtp-range-label dtp-range-label-start');
        const startTitle = createElement('div', 'dtp-range-label-title');
        startTitle.textContent = labels.start || 'Start';
        this._startValueEl = createElement('div', 'dtp-range-label-value');
        this._startLabelEl.appendChild(startTitle);
        this._startLabelEl.appendChild(this._startValueEl);
        const onStartClick = (e) => {
            e.stopPropagation();
            this._selectingEnd = false;
            this._updateLabels();
            this._rebuildTime();
        };
        this._startLabelEl.addEventListener('click', onStartClick);
        this._endLabelEl = createElement('div', 'dtp-range-label dtp-range-label-end');
        const endTitle = createElement('div', 'dtp-range-label-title');
        endTitle.textContent = labels.end || 'End';
        this._endValueEl = createElement('div', 'dtp-range-label-value');
        this._endLabelEl.appendChild(endTitle);
        this._endLabelEl.appendChild(this._endValueEl);
        const onEndClick = (e) => {
            e.stopPropagation();
            this._selectingEnd = true;
            this._updateLabels();
            this._rebuildTime();
        };
        this._endLabelEl.addEventListener('click', onEndClick);
        this._labelsEl.appendChild(this._startLabelEl);
        this._labelsEl.appendChild(this._endLabelEl);
        // --- Layout: calendar left, time right ---
        const layout = createElement('div', 'dtp-mode-datetime-layout', container);
        const dateSection = createElement('div', 'dtp-mode-datetime-date', layout);
        this._timeContainer = createElement('div', 'dtp-mode-datetime-time', layout);
        // --- Calendar ---
        this._calendar = new Calendar(dateSection, {
            locale: ctx.locale,
            month: this._start || today(),
            value: this._getRangeValue(),
            min: ctx.options.min,
            max: ctx.options.max,
            calendarMonths: ctx.options.calendarMonths,
            calendarView: ctx.options.calendarView,
            showQuarterYearPicker: ctx.options.showQuarterYearPicker,
            showOuterDays: ctx.options.showOuterDays,
            showWeekNumbers: ctx.options.showWeekNumbers,
            highlightWeekends: ctx.options.highlightWeekends,
            selectMultiple: false,
            rangePreview: true,
            isDisabled: ctx.isDisabled,
            onSelect: (date) => this._handleDateSelect(date),
            onMonthChange: () => { },
        });
        // --- Time scroller (shows active slot) ---
        this._buildTime();
        this._updateLabels();
    }
    destroy() {
        this._calendar?.destroy();
        this._time?.destroy();
        this._labelsEl?.remove();
    }
    getValue() {
        return [new Date(this._start.getTime()), new Date(this._end.getTime())];
    }
    _handleDateSelect(date) {
        if (!this._selectingEnd) {
            // Selecting start — preserve time
            const h = this._start.getHours();
            const m = this._start.getMinutes();
            this._start = date;
            this._start.setHours(h, m, 0, 0);
            // Clear end and switch to end selection
            this._end = new Date(date.getTime());
            this._end.setHours(this._end.getHours(), this._end.getMinutes(), 0, 0);
            this._selectingEnd = true;
        }
        else {
            // Selecting end — preserve time
            const h = this._end.getHours();
            const m = this._end.getMinutes();
            if (isAfterDay(this._start, date) || isSameDay(this._start, date)) {
                // End before start: swap
                this._end = new Date(this._start.getTime());
                this._start = date;
                this._start.setHours(h, m, 0, 0);
            }
            else {
                this._end = date;
                this._end.setHours(h, m, 0, 0);
            }
            this._selectingEnd = false;
        }
        this._enforceEndAfterStart();
        this._updateLabels();
        this._rebuildTime();
        this._emitValue();
        requestAnimationFrame(() => {
            this._calendar?.setOptions({ value: this._getRangeValue() });
        });
    }
    _buildTime() {
        if (!this._timeContainer || !this._ctx)
            return;
        this._time = new TimeMode();
        const activeDate = this._selectingEnd ? this._end : this._start;
        const timeCtx = {
            ...this._ctx,
            value: activeDate,
            onValueChange: (d) => {
                if (!(d instanceof Date))
                    return;
                if (this._selectingEnd) {
                    this._end.setHours(d.getHours(), d.getMinutes(), 0, 0);
                }
                else {
                    this._start.setHours(d.getHours(), d.getMinutes(), 0, 0);
                }
                this._enforceEndAfterStart();
                this._updateLabels();
                this._emitValue();
                // If editing start time and same day, rebuild to update end constraints
                if (!this._selectingEnd && isSameDay(this._start, this._end)) ;
            },
        };
        // If editing end time on same day, constrain
        if (this._selectingEnd && isSameDay(this._start, this._end)) {
            timeCtx.options = {
                ...this._ctx.options,
                _minHour: this._start.getHours(),
                _minMinute: this._start.getMinutes(),
            };
        }
        this._time.render(this._timeContainer, timeCtx);
    }
    _rebuildTime() {
        if (!this._timeContainer)
            return;
        this._time?.destroy();
        this._timeContainer.innerHTML = '';
        this._buildTime();
    }
    _enforceEndAfterStart() {
        if (!isSameDay(this._start, this._end))
            return;
        const startMin = this._start.getHours() * 60 + this._start.getMinutes();
        const endMin = this._end.getHours() * 60 + this._end.getMinutes();
        if (endMin < startMin) {
            this._end.setHours(this._start.getHours(), this._start.getMinutes(), 0, 0);
        }
    }
    _emitValue() {
        if (this._ctx)
            this._ctx.onValueChange(this.getValue());
    }
    _updateLabels() {
        if (!this._startLabelEl || !this._endLabelEl || !this._ctx)
            return;
        if (this._pillEl) {
            this._pillEl.classList.toggle('dtp-range-pill-end', this._selectingEnd);
        }
        this._startLabelEl.classList.toggle('dtp-range-label-active', !this._selectingEnd);
        this._endLabelEl.classList.toggle('dtp-range-label-active', this._selectingEnd);
        const locale = this._ctx.locale;
        const overrides = {
            dateFormat: this._ctx.options.dateFormat,
            timeFormat: this._ctx.options.timeFormat,
        };
        if (this._startValueEl) {
            const d = formatDateWithLocale(this._start, locale, 'date', overrides);
            const t = formatDateWithLocale(this._start, locale, 'time', overrides);
            this._startValueEl.innerHTML = `${d} <span class="dtp-range-label-time">${t}</span>`;
        }
        if (this._endValueEl) {
            const d = formatDateWithLocale(this._end, locale, 'date', overrides);
            const t = formatDateWithLocale(this._end, locale, 'time', overrides);
            this._endValueEl.innerHTML = `${d} <span class="dtp-range-label-time">${t}</span>`;
        }
    }
    _getRangeValue() {
        return [this._start, this._end];
    }
}

class TimeRangeMode {
    constructor() {
        this._startTime = null;
        this._endTime = null;
        this._ctx = null;
        this._endSection = null;
        this._startVal = new Date();
        this._endVal = new Date();
    }
    render(container, ctx) {
        this._ctx = ctx;
        if (Array.isArray(ctx.value) && ctx.value.length >= 2) {
            this._startVal = new Date(ctx.value[0].getTime());
            this._endVal = new Date(ctx.value[1].getTime());
        }
        const wrapper = createElement('div', 'dtp-mode-timerange', container);
        const startSection = createElement('div', 'dtp-mode-timerange-start', wrapper);
        this._endSection = createElement('div', 'dtp-mode-timerange-end', wrapper);
        const labels = ctx.options.labels;
        if (labels.start) {
            const label = createElement('div', 'dtp-range-label');
            label.textContent = labels.start;
            startSection.prepend(label);
        }
        if (labels.end) {
            const label = createElement('div', 'dtp-range-label');
            label.textContent = labels.end;
            this._endSection.prepend(label);
        }
        this._startTime = new TimeMode();
        this._startTime.render(startSection, {
            ...ctx,
            value: this._startVal,
            onValueChange: (d) => {
                if (d instanceof Date) {
                    this._startVal = d;
                    this._enforceEndAfterStart();
                    this._rebuildEndTime();
                    ctx.onValueChange([this._startVal, this._endVal]);
                }
            },
        });
        this._buildEndTime();
    }
    destroy() {
        this._startTime?.destroy();
        this._endTime?.destroy();
    }
    getValue() {
        return [this._startVal, this._endVal];
    }
    _enforceEndAfterStart() {
        const startMin = this._startVal.getHours() * 60 + this._startVal.getMinutes();
        const endMin = this._endVal.getHours() * 60 + this._endVal.getMinutes();
        if (endMin < startMin) {
            this._endVal.setHours(this._startVal.getHours(), this._startVal.getMinutes(), 0, 0);
        }
    }
    _buildEndTime() {
        if (!this._endSection || !this._ctx)
            return;
        this._endTime = new TimeMode();
        const endCtx = {
            ...this._ctx,
            value: this._endVal,
            options: {
                ...this._ctx.options,
                _minHour: this._startVal.getHours(),
                _minMinute: this._startVal.getMinutes(),
            },
            onValueChange: (d) => {
                if (d instanceof Date) {
                    this._endVal = d;
                    this._enforceEndAfterStart();
                    this._ctx.onValueChange([this._startVal, this._endVal]);
                }
            },
        };
        this._endTime.render(this._endSection, endCtx);
    }
    _rebuildEndTime() {
        if (!this._endSection)
            return;
        this._endTime?.destroy();
        // Keep the label if present, remove only the scroller content
        const label = this._endSection.querySelector('.dtp-range-label');
        this._endSection.innerHTML = '';
        if (label)
            this._endSection.appendChild(label);
        this._buildEndTime();
    }
}

const CHEVRON_LEFT$1 = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
const CHEVRON_RIGHT$1 = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
class MonthMode {
    constructor() {
        this._value = null;
        this._ctx = null;
        this._el = null;
        this._viewYear = 0;
        this._cleanups = [];
    }
    render(container, ctx) {
        this._ctx = ctx;
        this._value = ctx.value instanceof Date ? new Date(ctx.value.getTime()) : null;
        const initial = this._value || today();
        this._viewYear = initial.getFullYear();
        this._el = createElement('div', 'dtp-calendar', container);
        this._renderView();
    }
    _renderView() {
        if (!this._el || !this._ctx)
            return;
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el.innerHTML = '';
        const { locale } = this._ctx;
        // Navigation bar
        const nav = createElement('div', 'dtp-calendar-nav');
        const titleWrap = createElement('div', 'dtp-calendar-nav-title-wrap');
        const title = createElement('span', 'dtp-calendar-nav-title');
        title.style.cursor = 'default';
        title.textContent = String(this._viewYear);
        titleWrap.appendChild(title);
        const prevBtn = createElement('button', 'dtp-calendar-nav-prev');
        prevBtn.innerHTML = CHEVRON_LEFT$1;
        setAttr(prevBtn, { type: 'button', 'aria-label': 'Previous year' });
        const nextBtn = createElement('button', 'dtp-calendar-nav-next');
        nextBtn.innerHTML = CHEVRON_RIGHT$1;
        setAttr(nextBtn, { type: 'button', 'aria-label': 'Next year' });
        const onPrev = (e) => { e.stopPropagation(); this._viewYear--; this._renderView(); };
        const onNext = (e) => { e.stopPropagation(); this._viewYear++; this._renderView(); };
        prevBtn.addEventListener('click', onPrev);
        nextBtn.addEventListener('click', onNext);
        this._cleanups.push(() => prevBtn.removeEventListener('click', onPrev));
        this._cleanups.push(() => nextBtn.removeEventListener('click', onNext));
        nav.appendChild(titleWrap);
        nav.appendChild(prevBtn);
        nav.appendChild(nextBtn);
        this._el.appendChild(nav);
        // Month grid (3x4)
        const pickerView = createElement('div', 'dtp-picker-view');
        const grid = createElement('div', 'dtp-picker-grid');
        const selectedMonth = this._value ? this._value.getMonth() : -1;
        const selectedYear = this._value ? this._value.getFullYear() : -1;
        for (let m = 0; m < 12; m++) {
            const cell = createElement('button', 'dtp-picker-cell');
            setAttr(cell, { type: 'button' });
            cell.textContent = locale.monthNamesShort[m];
            if (m === selectedMonth && this._viewYear === selectedYear) {
                addClass(cell, 'dtp-picker-cell-active');
            }
            // Min/max constraints at month level
            if (this._isMonthDisabled(this._viewYear, m)) {
                addClass(cell, 'dtp-disabled');
                setAttr(cell, { 'aria-disabled': 'true' });
                cell.tabIndex = -1;
            }
            else {
                const onClick = (e) => {
                    e.stopPropagation();
                    this._value = new Date(this._viewYear, m, 1);
                    this._ctx?.onValueChange(this._value);
                    this._renderView();
                };
                cell.addEventListener('click', onClick);
                this._cleanups.push(() => cell.removeEventListener('click', onClick));
            }
            grid.appendChild(cell);
        }
        pickerView.appendChild(grid);
        this._el.appendChild(pickerView);
    }
    _isMonthDisabled(year, month) {
        if (!this._ctx)
            return false;
        const { min, max } = this._ctx.options;
        if (min) {
            const minYear = min.getFullYear();
            const minMonth = min.getMonth();
            if (year < minYear || (year === minYear && month < minMonth))
                return true;
        }
        if (max) {
            const maxYear = max.getFullYear();
            const maxMonth = max.getMonth();
            if (year > maxYear || (year === maxYear && month > maxMonth))
                return true;
        }
        return false;
    }
    destroy() {
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el?.remove();
        this._el = null;
    }
    getValue() {
        return this._value;
    }
}

const CHEVRON_LEFT = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
const CHEVRON_RIGHT = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
class YearMode {
    constructor() {
        this._value = null;
        this._ctx = null;
        this._el = null;
        this._yearsPage = 0;
        this._cleanups = [];
    }
    render(container, ctx) {
        this._ctx = ctx;
        this._value = ctx.value instanceof Date ? new Date(ctx.value.getTime()) : null;
        const initial = this._value || today();
        const year = initial.getFullYear();
        this._yearsPage = year - (year % 12);
        this._el = createElement('div', 'dtp-calendar', container);
        this._renderView();
    }
    _renderView() {
        if (!this._el || !this._ctx)
            return;
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el.innerHTML = '';
        // Navigation bar
        const nav = createElement('div', 'dtp-calendar-nav');
        const titleWrap = createElement('div', 'dtp-calendar-nav-title-wrap');
        const title = createElement('span', 'dtp-calendar-nav-title');
        title.style.cursor = 'default';
        title.textContent = `${this._yearsPage} – ${this._yearsPage + 11}`;
        titleWrap.appendChild(title);
        const prevBtn = createElement('button', 'dtp-calendar-nav-prev');
        prevBtn.innerHTML = CHEVRON_LEFT;
        setAttr(prevBtn, { type: 'button', 'aria-label': 'Previous years' });
        const nextBtn = createElement('button', 'dtp-calendar-nav-next');
        nextBtn.innerHTML = CHEVRON_RIGHT;
        setAttr(nextBtn, { type: 'button', 'aria-label': 'Next years' });
        const onPrev = (e) => { e.stopPropagation(); this._yearsPage -= 12; this._renderView(); };
        const onNext = (e) => { e.stopPropagation(); this._yearsPage += 12; this._renderView(); };
        prevBtn.addEventListener('click', onPrev);
        nextBtn.addEventListener('click', onNext);
        this._cleanups.push(() => prevBtn.removeEventListener('click', onPrev));
        this._cleanups.push(() => nextBtn.removeEventListener('click', onNext));
        nav.appendChild(titleWrap);
        nav.appendChild(prevBtn);
        nav.appendChild(nextBtn);
        this._el.appendChild(nav);
        // Year grid (3x4)
        const pickerView = createElement('div', 'dtp-picker-view');
        const grid = createElement('div', 'dtp-picker-grid');
        const selectedYear = this._value ? this._value.getFullYear() : -1;
        for (let i = 0; i < 12; i++) {
            const year = this._yearsPage + i;
            const cell = createElement('button', 'dtp-picker-cell');
            setAttr(cell, { type: 'button' });
            cell.textContent = String(year);
            if (year === selectedYear) {
                addClass(cell, 'dtp-picker-cell-active');
            }
            // Min/max constraints at year level
            if (this._isYearDisabled(year)) {
                addClass(cell, 'dtp-disabled');
                setAttr(cell, { 'aria-disabled': 'true' });
                cell.tabIndex = -1;
            }
            else {
                const onClick = (e) => {
                    e.stopPropagation();
                    this._value = new Date(year, 0, 1);
                    this._ctx?.onValueChange(this._value);
                    this._renderView();
                };
                cell.addEventListener('click', onClick);
                this._cleanups.push(() => cell.removeEventListener('click', onClick));
            }
            grid.appendChild(cell);
        }
        pickerView.appendChild(grid);
        this._el.appendChild(pickerView);
    }
    _isYearDisabled(year) {
        if (!this._ctx)
            return false;
        const { min, max } = this._ctx.options;
        if (min && year < min.getFullYear())
            return true;
        if (max && year > max.getFullYear())
            return true;
        return false;
    }
    destroy() {
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el?.remove();
        this._el = null;
    }
    getValue() {
        return this._value;
    }
}

class Controls {
    constructor(container, options) {
        this._cleanups = [];
        const isMobile = options.mobile || false;
        this._el = createElement('div', isMobile ? 'dtp-controls dtp-controls-mobile' : 'dtp-controls');
        const { locale, headerText, onSet, onCancel } = options;
        const setText = options.setText || locale.setText;
        const cancelText = options.cancelText || locale.cancelText;
        // Cancel button
        const cancelBtn = createElement('button', isMobile ? 'dtp-btn dtp-btn-cancel dtp-btn-mobile' : 'dtp-btn dtp-btn-cancel');
        cancelBtn.textContent = cancelText;
        setAttr(cancelBtn, { type: 'button', 'aria-label': cancelText });
        const onCancelClick = (e) => { e.stopPropagation(); onCancel(); };
        cancelBtn.addEventListener('click', onCancelClick);
        this._cleanups.push(() => cancelBtn.removeEventListener('click', onCancelClick));
        this._el.appendChild(cancelBtn);
        // Clear button (optional — for multi-select)
        if (options.onClear) {
            const clearText = options.clearText || locale.clearText;
            const clearBtn = createElement('button', isMobile ? 'dtp-btn dtp-btn-clear dtp-btn-mobile' : 'dtp-btn dtp-btn-clear');
            clearBtn.textContent = clearText;
            setAttr(clearBtn, { type: 'button', 'aria-label': clearText });
            const onClearClick = (e) => { e.stopPropagation(); options.onClear(); };
            clearBtn.addEventListener('click', onClearClick);
            this._cleanups.push(() => clearBtn.removeEventListener('click', onClearClick));
            this._el.appendChild(clearBtn);
        }
        // Header (center) — desktop only
        if (headerText !== false && !isMobile) {
            const header = createElement('div', 'dtp-controls-header');
            header.textContent = headerText || '';
            this._el.appendChild(header);
        }
        // Set button
        const setBtn = createElement('button', isMobile ? 'dtp-btn dtp-btn-set dtp-btn-mobile' : 'dtp-btn dtp-btn-set');
        setBtn.textContent = setText;
        setAttr(setBtn, { type: 'button', 'aria-label': setText });
        const onSetClick = (e) => { e.stopPropagation(); onSet(); };
        setBtn.addEventListener('click', onSetClick);
        this._cleanups.push(() => setBtn.removeEventListener('click', onSetClick));
        this._el.appendChild(setBtn);
        container.appendChild(this._el);
        // Live region for screen reader announcements
        this._liveRegion = createElement('div', 'dtp-live-region');
        setAttr(this._liveRegion, {
            'aria-live': 'polite',
            'aria-atomic': 'true',
            role: 'status',
        });
        container.appendChild(this._liveRegion);
    }
    announce(message) {
        this._liveRegion.textContent = '';
        requestAnimationFrame(() => {
            this._liveRegion.textContent = message;
        });
    }
    destroy() {
        this._cleanups.forEach(fn => fn());
        this._cleanups = [];
        this._el.remove();
        this._liveRegion.remove();
    }
}

/**
 * DateTimePicker — zero-dependency date/time picker with iOS theme.
 *
 * @example
 * ```js
 * const picker = new DateTimePicker('#my-input', { mode: 'date' });
 * picker.open();
 * ```
 */
class DateTimePicker {
    constructor(target, options) {
        this._value = null;
        this._tempValue = null;
        this._open = false;
        this._destroyed = false;
        this._closedAt = 0; // Timestamp to debounce reopen on focus
        // Rendering state
        this._display = null;
        this._mode = null;
        this._controls = null;
        this._themeManager = null;
        this._rootEl = null;
        this._keyHandler = null;
        this._timeMaskDigits = '';
        this._timeMaskActive = false;
        this._triggerHandler = (e) => {
            if (this._open)
                return;
            if (e.type === 'focus' && Date.now() - this._closedAt < 300)
                return;
            if (this._isTimeEditable() && e.type === 'focus') {
                this._initTimeMask();
                return;
            }
            this.open();
        };
        this._inputKeyHandler = (e) => {
            const input = this._element;
            // ArrowDown opens the scroller picker
            if (e.key === 'ArrowDown' && !this._open) {
                e.preventDefault();
                this.open();
                return;
            }
            if (!this._isTimeEditable())
                return;
            // Digit input for masked time
            if (e.key >= '0' && e.key <= '9') {
                e.preventDefault();
                if (!this._timeMaskActive)
                    this._initTimeMask();
                if (this._timeMaskDigits.length < 4) {
                    this._timeMaskDigits += e.key;
                    this._updateTimeMask();
                }
                return;
            }
            // Backspace removes last digit
            if (e.key === 'Backspace') {
                e.preventDefault();
                if (this._timeMaskDigits.length > 0) {
                    this._timeMaskDigits = this._timeMaskDigits.slice(0, -1);
                    this._updateTimeMask();
                }
                else {
                    this._timeMaskActive = false;
                    this._writeToInput();
                }
                return;
            }
            // Enter confirms whatever is typed
            if (e.key === 'Enter') {
                e.preventDefault();
                if (this._timeMaskDigits.length >= 3) {
                    // Pad to 4 digits: "930" → "0930"
                    const padded = this._timeMaskDigits.padStart(4, '0');
                    const hours = parseInt(padded.slice(0, 2), 10);
                    const minutes = parseInt(padded.slice(2, 4), 10);
                    if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
                        const date = this._value instanceof Date ? new Date(this._value.getTime()) : new Date();
                        date.setHours(hours, minutes, 0, 0);
                        this.setVal(date);
                    }
                }
                this._timeMaskDigits = '';
                this._timeMaskActive = false;
                input.blur();
                return;
            }
            // Escape cancels mask
            if (e.key === 'Escape') {
                this._timeMaskDigits = '';
                this._timeMaskActive = false;
                this._writeToInput();
                input.blur();
                return;
            }
            // Colon/dot: skip to minutes (pad hours)
            if (e.key === ':' || e.key === '.') {
                e.preventDefault();
                if (this._timeMaskDigits.length > 0 && this._timeMaskDigits.length < 2) {
                    this._timeMaskDigits = this._timeMaskDigits.padStart(2, '0');
                    this._updateTimeMask();
                }
                return;
            }
        };
        this._inputBlurHandler = () => {
            if (!this._isTimeEditable())
                return;
            if (this._open)
                return;
            // If mask is active with partial input, try to parse it
            if (this._timeMaskActive && this._timeMaskDigits.length >= 3) {
                const padded = this._timeMaskDigits.padStart(4, '0');
                const hours = parseInt(padded.slice(0, 2), 10);
                const minutes = parseInt(padded.slice(2, 4), 10);
                if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
                    const date = this._value instanceof Date ? new Date(this._value.getTime()) : new Date();
                    date.setHours(hours, minutes, 0, 0);
                    this.setVal(date);
                }
            }
            this._timeMaskDigits = '';
            this._timeMaskActive = false;
            this._writeToInput();
        };
        const el = typeof target === 'string' ? document.querySelector(target) : target;
        if (!el) {
            throw new Error(`DateTimePicker: target element not found: ${target}`);
        }
        this._element = el;
        this._options = resolveOptions(options || {});
        this._locale = this._resolveLocale(this._options.locale);
        this._responsive = new ResponsiveManager(this._options, (_bp, merged) => {
            this._activeOptions = merged;
            if (this._open) {
                this._teardown();
                this._setup();
            }
        });
        this._activeOptions = this._responsive.getActiveOptions();
        this._bindTrigger();
        this._fireEvent('onInit');
        // Inline: auto-open immediately
        if (this._activeOptions.display === 'inline') {
            this.open();
        }
    }
    /** Opens the picker overlay. No-op if already open or destroyed. */
    open() {
        if (this._destroyed || this._open)
            return;
        // Debounce: don't reopen within 200ms of closing (prevents focus-triggered reopen)
        if (Date.now() - this._closedAt < 200)
            return;
        // State is settled before dismissing the others: their onCancel/onClose callbacks run
        // synchronously, and must find this instance in a consistent state — the `_open` flag
        // makes a re-entrant open() a no-op, and `_tempValue` makes a re-entrant close() commit
        // the value the picker already holds rather than a stale one.
        this._open = true;
        this._tempValue = this._cloneValue(this._value);
        this._closeOthers();
        if (!this._open)
            return; // a foreign callback closed us again
        this._setup();
        this._fireEvent('onOpen');
    }
    /** Closes the picker and commits the current selection. Fires onSet, onChange, onClose. */
    close() {
        if (this._destroyed || !this._open)
            return;
        this._value = this._tempValue;
        this._open = false;
        this._closedAt = Date.now();
        this._teardown();
        this._writeToInput();
        this._fireValueEvent('onSet', this._value);
        this._fireValueEvent('onChange', this._value);
        this._fireValueEvent('onClose', this._value);
    }
    /** Closes the picker and reverts to the pre-open value. Fires onCancel, onClose. */
    cancel() {
        if (this._destroyed || !this._open)
            return;
        this._tempValue = null;
        this._open = false;
        this._closedAt = Date.now();
        this._teardown();
        this._fireEvent('onCancel');
        this._fireValueEvent('onClose', this._value);
    }
    /** Removes the picker from the DOM and unbinds all events. Fires onDestroy. */
    destroy() {
        if (this._destroyed)
            return;
        this._fireEvent('onDestroy');
        if (this._open) {
            this._open = false;
            this._teardown();
        }
        this._responsive.destroy();
        this._unbindTrigger();
        this._destroyed = true;
    }
    /** Returns the current confirmed value. */
    getVal() {
        return this._value;
    }
    /** Sets the value programmatically and fires onChange. */
    setVal(value) {
        this._value = value;
        this._writeToInput();
        this._fireValueEvent('onChange', this._value);
        if (this._open) {
            this._teardown();
            this._tempValue = this._cloneValue(this._value);
            this._setup();
        }
    }
    /** Merges new options into the picker and re-renders if open. */
    setOptions(opts) {
        this._options = deepMerge(this._options, opts);
        if (opts.locale) {
            this._locale = this._resolveLocale(opts.locale);
        }
        this._responsive.updateBaseOptions(this._options);
        this._activeOptions = this._responsive.getActiveOptions();
        if (this._open) {
            this._teardown();
            this._setup();
        }
    }
    /** Returns whether the picker is currently open.  */
    isOpen() {
        return this._open;
    }
    getLocale() {
        return this._locale;
    }
    getActiveOptions() {
        return this._activeOptions;
    }
    getElement() {
        return this._element;
    }
    // --- Internal: Single-open enforcement ---
    /**
     * Enforces `allowMultipleOpen`. When the current display disallows more than one open
     * picker, opening this one dismisses everything else that is open.
     */
    _closeOthers() {
        if (!this._participatesInAutoClose())
            return;
        if (allowsMultipleOpen(this._activeOptions))
            return;
        closeOtherPickers(this);
    }
    /** Inline pickers are always mounted, so they neither dismiss others nor get dismissed. */
    _participatesInAutoClose() {
        return this._activeOptions.display !== 'inline';
    }
    // --- Internal: Setup / Teardown ---
    _setup() {
        const opts = this._activeOptions;
        const isMobile = isMobileDisplay(opts.display);
        const isInline = opts.display === 'inline';
        const isDesktopDisplay = opts.display === 'anchored' || isInline;
        // Mobile gets toolbar buttons; desktop multi-select and datetimerange also need toolbar
        const needsToolbar = isMobile
            || (isDesktopDisplay && opts.mode === 'date' && opts.selectMultiple)
            || (isDesktopDisplay && opts.mode === 'daterange')
            || (isDesktopDisplay && opts.mode === 'datetimerange')
            || (isDesktopDisplay && opts.mode === 'timerange');
        // Build content
        this._rootEl = createElement('div', 'dtp-root');
        if (opts.cssClass)
            this._rootEl.classList.add(opts.cssClass);
        // Theme
        this._themeManager = new ThemeManager(this._rootEl, opts.theme);
        // Mode content area
        const modeContainer = createElement('div', 'dtp-mode-content', this._rootEl);
        // Toolbar: mobile always below content; desktop multi-select also gets toolbar below
        if (needsToolbar) {
            const hasClear = (opts.mode === 'date' && opts.selectMultiple)
                || opts.mode === 'daterange'
                || opts.mode === 'timerange'
                || opts.mode === 'datetimerange';
            this._controls = new Controls(this._rootEl, {
                locale: this._locale,
                headerText: false,
                setText: opts.setText || this._locale.setText,
                cancelText: opts.cancelText || this._locale.cancelText,
                onSet: () => this.close(),
                onCancel: () => this.cancel(),
                onClear: hasClear ? () => {
                    this._tempValue = null;
                    this._teardown();
                    this._setup();
                } : undefined,
                mobile: true,
            });
        }
        // Mode — on mobile, force single month and disable quarter/year picker
        const modeOpts = isMobile ? {
            ...opts,
            calendarMonths: 1,
            calendarView: 'month',
            showQuarterYearPicker: false,
        } : opts;
        this._mode = this._createMode(opts.mode);
        const modeCtx = {
            options: modeOpts,
            locale: this._locale,
            value: this._tempValue,
            isDisabled: (date) => this._isDateDisabled(date, opts),
            onValueChange: (val) => {
                this._tempValue = val;
                this._announceValue(val);
                // Inline: commit immediately on every selection
                if (isInline && val) {
                    this._value = val;
                    this._writeToInput();
                    this._fireValueEvent('onSet', this._value);
                    this._fireValueEvent('onChange', this._value);
                }
                // Auto-close on desktop — all modes (never for inline)
                if (isDesktopDisplay && !isInline && val) {
                    // Date: close immediately after selection
                    // Daterange: close when both start+end selected
                    // Time/datetime/timerange/datetimerange: close after scroller settles
                    if ((opts.mode === 'date' || opts.mode === 'month' || opts.mode === 'year') && !opts.selectMultiple) {
                        setTimeout(() => { if (this._open)
                            this.close(); }, 180);
                    }
                    else if (opts.mode !== 'daterange' && opts.mode !== 'datetimerange' && opts.mode !== 'timerange' && !opts.selectMultiple) {
                        // Scroller-based modes: slightly longer delay for the wheel to settle
                        setTimeout(() => { if (this._open)
                            this.close(); }, 600);
                    }
                }
            },
        };
        this._mode.render(modeContainer, modeCtx);
        // Ensure aria-live region exists even without toolbar
        if (!needsToolbar) {
            const liveRegion = createElement('div', 'dtp-live-region');
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            liveRegion.setAttribute('role', 'status');
            this._rootEl.appendChild(liveRegion);
            this._controls = {
                announce: (msg) => {
                    liveRegion.textContent = '';
                    requestAnimationFrame(() => { liveRegion.textContent = msg; });
                },
                destroy: () => { liveRegion.remove(); },
            };
        }
        // Display
        this._display = createDisplay(opts.display);
        this._display.mount({
            anchor: this._element,
            content: this._rootEl,
            onClose: () => this.cancel(),
        });
        // Keyboard
        this._setupKeyboard();
        // Visible to other pickers enforcing allowMultipleOpen
        if (this._participatesInAutoClose())
            registerOpenPicker(this);
        // Focus the first interactive element
        requestAnimationFrame(() => {
            const firstBtn = this._rootEl?.querySelector('button');
            firstBtn?.focus();
        });
    }
    _teardown() {
        unregisterOpenPicker(this);
        this._removeKeyboard();
        this._mode?.destroy();
        this._mode = null;
        this._controls?.destroy();
        this._controls = null;
        this._themeManager?.destroy();
        this._themeManager = null;
        this._display?.unmount();
        this._display = null;
        this._rootEl = null;
    }
    // --- Internal: Mode factory ---
    _createMode(mode) {
        switch (mode) {
            case 'date': return new DateMode();
            case 'month': return new MonthMode();
            case 'year': return new YearMode();
            case 'time': return new TimeMode();
            case 'datetime': return new DateTimeMode();
            case 'daterange': return new DateRangeMode();
            case 'datetimerange': return new DateTimeRangeMode();
            case 'timerange': return new TimeRangeMode();
        }
    }
    // --- Internal: Disabled dates logic ---
    _isDateDisabled(date, opts) {
        const { disabled } = opts;
        if (!disabled)
            return false;
        if (typeof disabled === 'function')
            return disabled(date);
        if (Array.isArray(disabled)) {
            return disabled.some(entry => this._matchesDisabledEntry(date, entry));
        }
        return false;
    }
    _matchesDisabledEntry(date, entry) {
        if (entry instanceof Date)
            return isSameDay(date, entry);
        if (typeof entry === 'string') {
            try {
                return isSameDay(date, parseDate(entry));
            }
            catch {
                return false;
            }
        }
        if ('start' in entry && 'end' in entry) {
            const range = entry;
            const start = range.start instanceof Date ? range.start : parseDate(range.start);
            const end = range.end instanceof Date ? range.end : parseDate(range.end);
            return date >= start && date <= end;
        }
        if ('recurring' in entry) {
            return this._matchesRecurring(date, entry.recurring);
        }
        return false;
    }
    _matchesRecurring(date, rule) {
        const dayOfWeek = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'][date.getDay()];
        switch (rule.repeat) {
            case 'daily': return true;
            case 'weekly':
                if (!rule.weekDays)
                    return false;
                return rule.weekDays.split(',').map(s => s.trim()).includes(dayOfWeek);
            case 'monthly': return rule.day === date.getDate();
            case 'yearly': return rule.day === date.getDate() && rule.month === (date.getMonth() + 1);
            default: return false;
        }
    }
    // --- Internal: Keyboard ---
    _setupKeyboard() {
        this._keyHandler = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                this.cancel();
            }
        };
        document.addEventListener('keydown', this._keyHandler);
    }
    _removeKeyboard() {
        if (this._keyHandler) {
            document.removeEventListener('keydown', this._keyHandler);
            this._keyHandler = null;
        }
    }
    // --- Internal: Announcements ---
    _announceValue(val) {
        if (!this._controls || !val)
            return;
        const fmtMode = this._getFmtMode();
        const overrides = this._getFormatOverrides();
        if (Array.isArray(val)) {
            if (this._activeOptions.selectMultiple) {
                const count = val.length;
                const max = this._activeOptions.selectMax;
                const msg = max != null
                    ? `${count} ${this._locale.ofText} ${max} ${this._locale.selectedText}`
                    : `${count} ${this._locale.selectedText}`;
                this._controls.announce(msg);
            }
            else if (val.length === 1) {
                this._controls.announce(`Start: ${formatDateWithLocale(val[0], this._locale, fmtMode, overrides)}`);
            }
            else if (val.length >= 2) {
                this._controls.announce(formatRange(val[0], val[1], this._locale, fmtMode, overrides));
            }
        }
        else {
            this._controls.announce(formatDateWithLocale(val, this._locale, fmtMode, overrides));
        }
    }
    // --- Internal: Format mode helper ---
    _getFmtMode() {
        const m = this._activeOptions.mode;
        if (m === 'month')
            return 'month';
        if (m === 'year')
            return 'year';
        if (m === 'time' || m === 'timerange')
            return 'time';
        if (m === 'datetime' || m === 'datetimerange')
            return 'datetime';
        return 'date';
    }
    _getFormatOverrides() {
        return {
            dateFormat: this._activeOptions.dateFormat,
            timeFormat: this._activeOptions.timeFormat,
        };
    }
    // --- Internal: Locale ---
    _resolveLocale(name) {
        const pack = localeRegistry.get(name);
        if (!pack) {
            console.warn(`DateTimePicker: locale "${name}" not found, falling back to "en".`);
            return localeRegistry.get('en');
        }
        return pack;
    }
    // --- Internal: Event dispatch ---
    _fireEvent(name) {
        const cb = this._activeOptions[name];
        if (typeof cb === 'function') {
            cb({ inst: this });
        }
    }
    _fireValueEvent(name, value) {
        const cb = this._activeOptions[name];
        if (typeof cb === 'function') {
            cb({ inst: this, value });
        }
    }
    // --- Internal: Trigger binding ---
    _isTimeEditable() {
        const m = this._activeOptions.mode;
        const d = this._activeOptions.display;
        const isTimeBased = m === 'time' || m === 'datetime' || m === 'timerange' || m === 'datetimerange';
        const isDesktop = d === 'anchored' || d === 'inline';
        return isTimeBased && isDesktop && this._element instanceof HTMLInputElement;
    }
    _initTimeMask() {
        if (this._timeMaskActive)
            return;
        this._timeMaskActive = true;
        this._timeMaskDigits = '';
        const input = this._element;
        if (!this._value) {
            input.value = '--:--';
        }
    }
    _updateTimeMask() {
        const input = this._element;
        const d = this._timeMaskDigits.padEnd(4, '-');
        const h = d.slice(0, 2).replace(/-/g, '-');
        const m = d.slice(2, 4).replace(/-/g, '-');
        input.value = `${h}:${m}`;
        if (this._timeMaskDigits.length >= 4) {
            const hours = parseInt(this._timeMaskDigits.slice(0, 2), 10);
            const minutes = parseInt(this._timeMaskDigits.slice(2, 4), 10);
            if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
                const date = this._value instanceof Date ? new Date(this._value.getTime()) : new Date();
                date.setHours(hours, minutes, 0, 0);
                this.setVal(date);
            }
            this._timeMaskDigits = '';
            this._timeMaskActive = false;
            this._element.blur();
        }
    }
    _bindTrigger() {
        this._element.addEventListener('click', this._triggerHandler);
        if (this._element instanceof HTMLInputElement) {
            this._element.addEventListener('focus', this._triggerHandler);
            this._element.addEventListener('keydown', this._inputKeyHandler);
            this._element.addEventListener('blur', this._inputBlurHandler);
            // Make time inputs editable on desktop
            if (this._isTimeEditable()) {
                this._element.removeAttribute('readonly');
                // Show placeholder mask
                if (!this._value) {
                    this._element.placeholder = '--:--';
                }
            }
        }
    }
    _unbindTrigger() {
        this._element.removeEventListener('click', this._triggerHandler);
        if (this._element instanceof HTMLInputElement) {
            this._element.removeEventListener('focus', this._triggerHandler);
            this._element.removeEventListener('keydown', this._inputKeyHandler);
            this._element.removeEventListener('blur', this._inputBlurHandler);
        }
    }
    // --- Internal: Input write-back ---
    _writeToInput() {
        if (!(this._element instanceof HTMLInputElement))
            return;
        if (!this._value) {
            this._element.value = '';
            return;
        }
        const fmtMode = this._getFmtMode();
        const overrides = this._getFormatOverrides();
        if (Array.isArray(this._value) && this._activeOptions.selectMultiple) {
            // Multi-select: comma-separated dates
            this._element.value = this._value.map(d => formatDateWithLocale(d, this._locale, fmtMode, overrides)).join(', ');
        }
        else if (Array.isArray(this._value) && this._value.length >= 2) {
            this._element.value = formatRange(this._value[0], this._value[1], this._locale, fmtMode, overrides);
        }
        else if (Array.isArray(this._value) && this._value.length === 1) {
            this._element.value = formatDateWithLocale(this._value[0], this._locale, fmtMode, overrides);
        }
        else if (this._value instanceof Date) {
            this._element.value = formatDateWithLocale(this._value, this._locale, fmtMode, overrides);
        }
    }
    // --- Internal: Value clone ---
    _cloneValue(v) {
        if (!v)
            return null;
        if (Array.isArray(v))
            return v.map(d => new Date(d.getTime()));
        return new Date(v.getTime());
    }
    // --- Static: Locale management ---
    static registerLocale(name, pack) {
        localeRegistry.set(name, pack);
    }
    static getLocale(name) {
        return localeRegistry.get(name);
    }
}

export { DateTimePicker };
//# sourceMappingURL=index.js.map
